import { Password } from "@mui/icons-material";

export const esignIcons = {
  GroupsIconActive: (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.75 10.1875C17.75 11.7063 16.5188 12.9375 15 12.9375V14.9375C17.6234 14.9375 19.75 12.8109 19.75 10.1875H17.75ZM15 12.9375C13.4812 12.9375 12.25 11.7063 12.25 10.1875H10.25C10.25 12.8109 12.3766 14.9375 15 14.9375V12.9375ZM12.25 10.1875C12.25 8.66872 13.4812 7.4375 15 7.4375V5.4375C12.3766 5.4375 10.25 7.56415 10.25 10.1875H12.25ZM15 7.4375C16.5188 7.4375 17.75 8.66872 17.75 10.1875H19.75C19.75 7.56415 17.6234 5.4375 15 5.4375V7.4375ZM11.25 18.6875H18.75V16.6875H11.25V18.6875ZM18.75 24.1875H11.25V26.1875H18.75V24.1875ZM11.25 24.1875C9.73122 24.1875 8.5 22.9563 8.5 21.4375H6.5C6.5 24.0609 8.62665 26.1875 11.25 26.1875V24.1875ZM21.5 21.4375C21.5 22.9563 20.2688 24.1875 18.75 24.1875V26.1875C21.3734 26.1875 23.5 24.0609 23.5 21.4375H21.5ZM18.75 18.6875C20.2688 18.6875 21.5 19.9187 21.5 21.4375H23.5C23.5 18.8141 21.3734 16.6875 18.75 16.6875V18.6875ZM11.25 16.6875C8.62665 16.6875 6.5 18.8141 6.5 21.4375H8.5C8.5 19.9187 9.73122 18.6875 11.25 18.6875V16.6875Z"
        fill="#185CB7"
      />
      <path
        d="M9.69018 13.4858C9.49302 13.1691 9.12308 13 8.75 13C7.1967 13 5.9375 11.7408 5.9375 10.1875C5.9375 8.6342 7.1967 7.375 8.75 7.375C9.12308 7.375 9.49302 7.20591 9.69018 6.88918C9.6989 6.87518 9.70767 6.8612 9.7165 6.84727C10.0447 6.32913 9.87843 5.5955 9.26875 5.52838C9.09842 5.50963 8.92533 5.5 8.75 5.5C6.16117 5.5 4.0625 7.59867 4.0625 10.1875C4.0625 12.7763 6.16117 14.875 8.75 14.875C8.92533 14.875 9.09842 14.8654 9.26875 14.8466C9.87843 14.7795 10.0447 14.0459 9.7165 13.5277C9.70767 13.5138 9.6989 13.4998 9.69018 13.4858Z"
        fill="#185CB7"
      />
      <path
        d="M5.88536 23.3961C5.74346 23.1593 5.49299 23 5.21698 23H5C3.4467 23 2.1875 21.7408 2.1875 20.1875C2.1875 18.6342 3.4467 17.375 5 17.375H5.21698C5.49299 17.375 5.74346 17.2157 5.88536 16.9789C6.23174 16.401 5.85586 15.5 5.18211 15.5H5C2.41117 15.5 0.3125 17.5987 0.3125 20.1875C0.3125 22.7763 2.41117 24.875 5 24.875H5.18211C5.85586 24.875 6.23174 23.974 5.88536 23.3961Z"
        fill="#185CB7"
      />
      <path
        d="M20.2835 13.5277C19.9552 14.0459 20.1216 14.7795 20.7312 14.8466C20.9016 14.8654 21.0747 14.875 21.25 14.875C23.8388 14.875 25.9375 12.7763 25.9375 10.1875C25.9375 7.59867 23.8388 5.5 21.25 5.5C21.0747 5.5 20.9016 5.50963 20.7312 5.52838C20.1216 5.5955 19.9552 6.32913 20.2835 6.84727C20.2923 6.8612 20.3011 6.87517 20.3098 6.88918C20.507 7.20591 20.8769 7.375 21.25 7.375C22.8033 7.375 24.0625 8.6342 24.0625 10.1875C24.0625 11.7408 22.8033 13 21.25 13C20.8769 13 20.507 13.1691 20.3098 13.4858C20.3011 13.4998 20.2923 13.5138 20.2835 13.5277Z"
        fill="#185CB7"
      />
      <path
        d="M24.1146 23.3961C23.7683 23.974 24.1441 24.875 24.8179 24.875H25C27.5888 24.875 29.6875 22.7763 29.6875 20.1875C29.6875 17.5987 27.5888 15.5 25 15.5H24.8179C24.1441 15.5 23.7683 16.401 24.1146 16.9789C24.2565 17.2157 24.507 17.375 24.783 17.375H25C26.5533 17.375 27.8125 18.6342 27.8125 20.1875C27.8125 21.7408 26.5533 23 25 23H24.783C24.507 23 24.2565 23.1593 24.1146 23.3961Z"
        fill="#185CB7"
      />
    </svg>
  ),

  GroupsIcon: (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.75 10.1875C17.75 11.7063 16.5188 12.9375 15 12.9375V14.9375C17.6234 14.9375 19.75 12.8109 19.75 10.1875H17.75ZM15 12.9375C13.4812 12.9375 12.25 11.7063 12.25 10.1875H10.25C10.25 12.8109 12.3766 14.9375 15 14.9375V12.9375ZM12.25 10.1875C12.25 8.66872 13.4812 7.4375 15 7.4375V5.4375C12.3766 5.4375 10.25 7.56415 10.25 10.1875H12.25ZM15 7.4375C16.5188 7.4375 17.75 8.66872 17.75 10.1875H19.75C19.75 7.56415 17.6234 5.4375 15 5.4375V7.4375ZM11.25 18.6875H18.75V16.6875H11.25V18.6875ZM18.75 24.1875H11.25V26.1875H18.75V24.1875ZM11.25 24.1875C9.73122 24.1875 8.5 22.9563 8.5 21.4375H6.5C6.5 24.0609 8.62665 26.1875 11.25 26.1875V24.1875ZM21.5 21.4375C21.5 22.9563 20.2688 24.1875 18.75 24.1875V26.1875C21.3734 26.1875 23.5 24.0609 23.5 21.4375H21.5ZM18.75 18.6875C20.2688 18.6875 21.5 19.9187 21.5 21.4375H23.5C23.5 18.8141 21.3734 16.6875 18.75 16.6875V18.6875ZM11.25 16.6875C8.62665 16.6875 6.5 18.8141 6.5 21.4375H8.5C8.5 19.9187 9.73122 18.6875 11.25 18.6875V16.6875Z"
        fill="#1D1D1D"
      />
      <path
        d="M9.69018 13.4858C9.49302 13.1691 9.12308 13 8.75 13C7.1967 13 5.9375 11.7408 5.9375 10.1875C5.9375 8.6342 7.1967 7.375 8.75 7.375C9.12308 7.375 9.49302 7.20591 9.69018 6.88918C9.6989 6.87518 9.70767 6.8612 9.7165 6.84727C10.0447 6.32913 9.87843 5.5955 9.26875 5.52838C9.09842 5.50963 8.92533 5.5 8.75 5.5C6.16117 5.5 4.0625 7.59867 4.0625 10.1875C4.0625 12.7763 6.16117 14.875 8.75 14.875C8.92533 14.875 9.09842 14.8654 9.26875 14.8466C9.87843 14.7795 10.0447 14.0459 9.7165 13.5277C9.70767 13.5138 9.6989 13.4998 9.69018 13.4858Z"
        fill="#1D1D1D"
      />
      <path
        d="M5.88536 23.3961C5.74346 23.1593 5.49299 23 5.21698 23H5C3.4467 23 2.1875 21.7408 2.1875 20.1875C2.1875 18.6342 3.4467 17.375 5 17.375H5.21698C5.49299 17.375 5.74346 17.2157 5.88536 16.9789C6.23174 16.401 5.85586 15.5 5.18211 15.5H5C2.41117 15.5 0.3125 17.5987 0.3125 20.1875C0.3125 22.7763 2.41117 24.875 5 24.875H5.18211C5.85586 24.875 6.23174 23.974 5.88536 23.3961Z"
        fill="#1D1D1D"
      />
      <path
        d="M20.2835 13.5277C19.9552 14.0459 20.1216 14.7795 20.7312 14.8466C20.9016 14.8654 21.0747 14.875 21.25 14.875C23.8388 14.875 25.9375 12.7763 25.9375 10.1875C25.9375 7.59867 23.8388 5.5 21.25 5.5C21.0747 5.5 20.9016 5.50963 20.7312 5.52838C20.1216 5.5955 19.9552 6.32913 20.2835 6.84727C20.2923 6.8612 20.3011 6.87517 20.3098 6.88918C20.507 7.20591 20.8769 7.375 21.25 7.375C22.8033 7.375 24.0625 8.6342 24.0625 10.1875C24.0625 11.7408 22.8033 13 21.25 13C20.8769 13 20.507 13.1691 20.3098 13.4858C20.3011 13.4998 20.2923 13.5138 20.2835 13.5277Z"
        fill="#1D1D1D"
      />
      <path
        d="M24.1146 23.3961C23.7683 23.974 24.1441 24.875 24.8179 24.875H25C27.5888 24.875 29.6875 22.7763 29.6875 20.1875C29.6875 17.5987 27.5888 15.5 25 15.5H24.8179C24.1441 15.5 23.7683 16.401 24.1146 16.9789C24.2565 17.2157 24.507 17.375 24.783 17.375H25C26.5533 17.375 27.8125 18.6342 27.8125 20.1875C27.8125 21.7408 26.5533 23 25 23H24.783C24.507 23 24.2565 23.1593 24.1146 23.3961Z"
        fill="#1D1D1D"
      />
    </svg>
  ),

  SecurityIcon: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6114 20L22.7347 19.5189L23.6114 20ZM6.38888 20L5.51219 20.4811L6.38888 20ZM3.78163 10.2608L2.7829 10.3113L3.78163 10.2608ZM21.5688 22.8493L22.3249 23.5038L21.5688 22.8493ZM8.4314 22.8493L9.18751 22.1949L8.4314 22.8493ZM26.2287 9.54612L27.228 9.5844L26.2287 9.54612ZM13.9999 20C13.9999 20.5523 14.4477 21 14.9999 21C15.5522 21 15.9999 20.5523 15.9999 20H13.9999ZM25.2295 9.50784C25.1308 12.0848 24.6282 16.0681 22.7347 19.5189L24.488 20.4811C26.599 16.6341 27.1244 12.2897 27.228 9.5844L25.2295 9.50784ZM22.7347 19.5189C22.2513 20.3998 21.581 21.3072 20.8127 22.1949L22.3249 23.5038C23.1502 22.5503 23.9149 21.5256 24.488 20.4811L22.7347 19.5189ZM9.18751 22.1949C8.41919 21.3072 7.74893 20.3998 7.26557 19.5189L5.51219 20.4811C6.08536 21.5256 6.85005 22.5503 7.67529 23.5038L9.18751 22.1949ZM7.26557 19.5189C5.42373 16.1624 4.89942 12.5688 4.78036 10.2104L2.7829 10.3113C2.91006 12.83 3.46947 16.7584 5.51219 20.4811L7.26557 19.5189ZM6.4634 8.60417H6.84949V6.60417H6.4634V8.60417ZM22.7862 7.875H23.5228V5.875H22.7862V7.875ZM19.5987 4.6875C19.5987 6.44791 21.0258 7.875 22.7862 7.875V5.875C22.1303 5.875 21.5987 5.34334 21.5987 4.6875H19.5987ZM6.84949 8.60417C8.81125 8.60417 10.4016 7.01384 10.4016 5.05208H8.40157C8.40157 5.90928 7.70668 6.60417 6.84949 6.60417V8.60417ZM11.9537 1.5C9.99189 1.5 8.40157 3.09032 8.40157 5.05208H10.4016C10.4016 4.19489 11.0965 3.5 11.9537 3.5V1.5ZM4.78036 10.2104C4.73701 9.35181 5.4439 8.60417 6.4634 8.60417V6.60417C4.46267 6.60417 2.67397 8.15346 2.7829 10.3113L4.78036 10.2104ZM20.8127 22.1949C19.5484 23.6556 18.7008 24.6263 17.8365 25.2595C17.0382 25.8443 16.2233 26.1384 15.0001 26.1384V28.1384C16.6333 28.1384 17.8653 27.7177 19.0185 26.8728C20.1058 26.0763 21.1144 24.9024 22.3249 23.5038L20.8127 22.1949ZM7.67529 23.5038C8.88585 24.9024 9.89445 26.0763 10.9817 26.8728C12.1349 27.7177 13.3669 28.1384 15.0001 28.1384V26.1384C13.7769 26.1384 12.962 25.8443 12.1637 25.2595C11.2994 24.6263 10.4518 23.6556 9.18751 22.1949L7.67529 23.5038ZM18.4112 3.5C19.067 3.5 19.5987 4.03166 19.5987 4.6875H21.5987C21.5987 2.92709 20.1716 1.5 18.4112 1.5V3.5ZM27.228 9.5844C27.3102 7.43777 25.535 5.875 23.5228 5.875V7.875C24.5388 7.875 25.2632 8.62859 25.2295 9.50784L27.228 9.5844ZM11.9537 3.5H18.4112V1.5H11.9537V3.5ZM13.9999 15V20H15.9999V15H13.9999ZM11.4999 12.5C11.4999 14.433 13.0669 16 14.9999 16V14C14.1715 14 13.4999 13.3284 13.4999 12.5H11.4999ZM14.9999 16C16.9329 16 18.4999 14.433 18.4999 12.5H16.4999C16.4999 13.3284 15.8284 14 14.9999 14V16ZM18.4999 12.5C18.4999 10.567 16.9329 9 14.9999 9V11C15.8284 11 16.4999 11.6716 16.4999 12.5H18.4999ZM14.9999 9C13.0669 9 11.4999 10.567 11.4999 12.5H13.4999C13.4999 11.6716 14.1715 11 14.9999 11V9Z"
        fill="#2D264B"
      />
    </svg>
  ),

  SecurityIconActive: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6114 20L22.7347 19.5189L23.6114 20ZM6.38888 20L5.51219 20.4811L6.38888 20ZM3.78163 10.2608L2.7829 10.3113L3.78163 10.2608ZM21.5688 22.8493L22.3249 23.5038L21.5688 22.8493ZM8.4314 22.8493L9.18751 22.1949L8.4314 22.8493ZM26.2287 9.54612L27.228 9.5844L26.2287 9.54612ZM13.9999 20C13.9999 20.5523 14.4477 21 14.9999 21C15.5522 21 15.9999 20.5523 15.9999 20H13.9999ZM25.2295 9.50784C25.1308 12.0848 24.6282 16.0681 22.7347 19.5189L24.488 20.4811C26.599 16.6341 27.1244 12.2897 27.228 9.5844L25.2295 9.50784ZM22.7347 19.5189C22.2513 20.3998 21.581 21.3072 20.8127 22.1949L22.3249 23.5038C23.1502 22.5503 23.9149 21.5256 24.488 20.4811L22.7347 19.5189ZM9.18751 22.1949C8.41919 21.3072 7.74893 20.3998 7.26557 19.5189L5.51219 20.4811C6.08536 21.5256 6.85005 22.5503 7.67529 23.5038L9.18751 22.1949ZM7.26557 19.5189C5.42373 16.1624 4.89942 12.5688 4.78036 10.2104L2.7829 10.3113C2.91006 12.83 3.46947 16.7584 5.51219 20.4811L7.26557 19.5189ZM6.4634 8.60417H6.84949V6.60417H6.4634V8.60417ZM22.7862 7.875H23.5228V5.875H22.7862V7.875ZM19.5987 4.6875C19.5987 6.44791 21.0258 7.875 22.7862 7.875V5.875C22.1303 5.875 21.5987 5.34334 21.5987 4.6875H19.5987ZM6.84949 8.60417C8.81125 8.60417 10.4016 7.01384 10.4016 5.05208H8.40157C8.40157 5.90928 7.70668 6.60417 6.84949 6.60417V8.60417ZM11.9537 1.5C9.99189 1.5 8.40157 3.09032 8.40157 5.05208H10.4016C10.4016 4.19489 11.0965 3.5 11.9537 3.5V1.5ZM4.78036 10.2104C4.73701 9.35181 5.4439 8.60417 6.4634 8.60417V6.60417C4.46267 6.60417 2.67397 8.15346 2.7829 10.3113L4.78036 10.2104ZM20.8127 22.1949C19.5484 23.6556 18.7008 24.6263 17.8365 25.2595C17.0382 25.8443 16.2233 26.1384 15.0001 26.1384V28.1384C16.6333 28.1384 17.8653 27.7177 19.0185 26.8728C20.1058 26.0763 21.1144 24.9024 22.3249 23.5038L20.8127 22.1949ZM7.67529 23.5038C8.88585 24.9024 9.89445 26.0763 10.9817 26.8728C12.1349 27.7177 13.3669 28.1384 15.0001 28.1384V26.1384C13.7769 26.1384 12.962 25.8443 12.1637 25.2595C11.2994 24.6263 10.4518 23.6556 9.18751 22.1949L7.67529 23.5038ZM18.4112 3.5C19.067 3.5 19.5987 4.03166 19.5987 4.6875H21.5987C21.5987 2.92709 20.1716 1.5 18.4112 1.5V3.5ZM27.228 9.5844C27.3102 7.43777 25.535 5.875 23.5228 5.875V7.875C24.5388 7.875 25.2632 8.62859 25.2295 9.50784L27.228 9.5844ZM11.9537 3.5H18.4112V1.5H11.9537V3.5ZM13.9999 15V20H15.9999V15H13.9999ZM11.4999 12.5C11.4999 14.433 13.0669 16 14.9999 16V14C14.1715 14 13.4999 13.3284 13.4999 12.5H11.4999ZM14.9999 16C16.9329 16 18.4999 14.433 18.4999 12.5H16.4999C16.4999 13.3284 15.8284 14 14.9999 14V16ZM18.4999 12.5C18.4999 10.567 16.9329 9 14.9999 9V11C15.8284 11 16.4999 11.6716 16.4999 12.5H18.4999ZM14.9999 9C13.0669 9 11.4999 10.567 11.4999 12.5H13.4999C13.4999 11.6716 14.1715 11 14.9999 11V9Z"
        fill="#185CB7"
      />
    </svg>
  ),

  EmailIcon: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 13.5C2.25 8.1967 2.25 5.54505 3.89752 3.89752C5.54505 2.25 8.1967 2.25 13.5 2.25C18.8033 2.25 21.455 2.25 23.1025 3.89752C24.75 5.54505 24.75 8.1967 24.75 13.5C24.75 18.8033 24.75 21.455 23.1025 23.1025C21.455 24.75 18.8033 24.75 13.5 24.75C8.1967 24.75 5.54505 24.75 3.89752 23.1025C2.25 21.455 2.25 18.8033 2.25 13.5Z"
        stroke="#1D1D1D"
        strokeWidth="2"
      />
      <path
        d="M2.25 14.625H5.80529C6.82361 14.625 7.33277 14.625 7.78032 14.8308C8.22788 15.0367 8.55924 15.4233 9.22195 16.1964L9.90305 16.9911C10.5658 17.7642 10.8971 18.1508 11.3447 18.3567C11.7922 18.5625 12.3014 18.5625 13.3197 18.5625H13.6803C14.6986 18.5625 15.2078 18.5625 15.6553 18.3567C16.1029 18.1508 16.4342 17.7642 17.0969 16.9911L17.7781 16.1964C18.4408 15.4233 18.7721 15.0367 19.2197 14.8308C19.6672 14.625 20.1764 14.625 21.1947 14.625H24.75"
        stroke="#1D1D1D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 7.875H18"
        stroke="#1D1D1D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11.25 11.8125H15.75"
        stroke="#1D1D1D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  EmailIconActive: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 13.5C2.25 8.1967 2.25 5.54505 3.89752 3.89752C5.54505 2.25 8.1967 2.25 13.5 2.25C18.8033 2.25 21.455 2.25 23.1025 3.89752C24.75 5.54505 24.75 8.1967 24.75 13.5C24.75 18.8033 24.75 21.455 23.1025 23.1025C21.455 24.75 18.8033 24.75 13.5 24.75C8.1967 24.75 5.54505 24.75 3.89752 23.1025C2.25 21.455 2.25 18.8033 2.25 13.5Z"
        stroke="#185CB7"
        strokeWidth="2"
      />
      <path
        d="M2.25 14.625H5.80529C6.82361 14.625 7.33277 14.625 7.78032 14.8308C8.22788 15.0367 8.55924 15.4233 9.22195 16.1964L9.90305 16.9911C10.5658 17.7642 10.8971 18.1508 11.3447 18.3567C11.7922 18.5625 12.3014 18.5625 13.3197 18.5625H13.6803C14.6986 18.5625 15.2078 18.5625 15.6553 18.3567C16.1029 18.1508 16.4342 17.7642 17.0969 16.9911L17.7781 16.1964C18.4408 15.4233 18.7721 15.0367 19.2197 14.8308C19.6672 14.625 20.1764 14.625 21.1947 14.625H24.75"
        stroke="#185CB7"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 7.875H18"
        stroke="#185CB7"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11.25 11.8125H15.75"
        stroke="#185CB7"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  AttachIcon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6339 7.20833L2.74029 6.31472C1.75324 5.32767 1.75324 3.72734 2.74029 2.74029C3.72734 1.75324 5.32767 1.75324 6.31472 2.74029L11.6764 8.10194C12.6634 9.089 12.6634 10.6893 11.6764 11.6764C10.6893 12.6634 9.089 12.6634 8.10194 11.6764L6.09132 9.66576C4.62175 8.19619 6.73569 6.21486 8.25 7.72917L9.29167 8.77083"
        stroke="#185CB7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  VisibilityIcon: (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.658 5.53374C15.886 5.85348 16 6.01335 16 6.25C16 6.48665 15.886 6.64652 15.658 6.96626C14.6334 8.40292 12.0169 11.5 8.5 11.5C4.98308 11.5 2.36657 8.40292 1.34203 6.96626C1.11401 6.64652 1 6.48665 1 6.25C1 6.01335 1.11401 5.85348 1.34203 5.53374C2.36657 4.09708 4.98308 1 8.5 1C12.0169 1 14.6334 4.09708 15.658 5.53374Z"
        stroke="#185CB7"
        strokeWidth="1.5"
      />
      <path
        d="M10.75 6.25C10.75 5.00736 9.74264 4 8.5 4C7.25736 4 6.25 5.00736 6.25 6.25C6.25 7.49264 7.25736 8.5 8.5 8.5C9.74264 8.5 10.75 7.49264 10.75 6.25Z"
        stroke="#185CB7"
        strokeWidth="1.5"
      />
    </svg>
  ),

  RemoveCircleIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_994_8534)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1821 11.385C12.402 11.6044 12.402 11.9644 12.1821 12.1838C11.9627 12.4031 11.6061 12.4031 11.3861 12.1838L9.00336 9.79877L6.60374 12.2006C6.38212 12.42 6.02326 12.42 5.80164 12.2006C5.58058 11.9756 5.58058 11.6156 5.80164 11.3963L8.20126 8.99437L5.8185 6.61501C5.59856 6.39563 5.59856 6.03561 5.8185 5.81623C6.03731 5.59686 6.39394 5.59686 6.61387 5.81623L8.99664 8.20123L11.4142 5.78252C11.6359 5.56314 11.9942 5.56314 12.2158 5.78252C12.4369 6.00752 12.4369 6.36185 12.2158 6.58685L9.79874 9.00563L12.1821 11.385ZM9 0C4.02919 0 0 4.0275 0 9C0 13.9725 4.02919 18 9 18C13.9708 18 18 13.9725 18 9C18 4.0275 13.9708 0 9 0Z"
          fill="#1D1D1D"
        />
      </g>
      <defs>
        <clipPath id="clip0_994_8534">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  editIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#clip0_625_5516)"
        transform="translate(2,4)"
        textAnchor="middle"
      >
        <path
          d="M13.75 6.5625V7.5C13.75 10.4463 13.75 11.9194 12.8347 12.8347C11.9194 13.75 10.4463 13.75 7.5 13.75C4.55372 13.75 3.08058 13.75 2.16529 12.8347C1.25 11.9194 1.25 10.4463 1.25 7.5C1.25 4.55372 1.25 3.08058 2.16529 2.16529C3.08058 1.25 4.55372 1.25 7.5 1.25H8.4375"
          stroke="#1D1D1D"
          strokeLinecap="round"
        />
        <path
          d="M10.813 1.7539L10.4075 2.15941L6.67949 5.88746L6.67948 5.88746C6.42697 6.13997 6.30072 6.26622 6.19214 6.40543C6.06406 6.56964 5.95425 6.74732 5.86465 6.93532C5.7887 7.0947 5.73223 7.26408 5.61931 7.60286L5.25776 8.6875L5.02382 9.38932C4.96825 9.55603 5.01164 9.73984 5.1359 9.8641C5.26016 9.98836 5.44397 10.0317 5.61068 9.97618L6.3125 9.74224L7.39714 9.38069L7.39717 9.38068C7.73593 9.26776 7.90531 9.2113 8.06468 9.13535C8.25268 9.04575 8.43036 8.93594 8.59457 8.80786C8.73378 8.69928 8.86004 8.57302 9.11254 8.32051L12.8406 4.59247L13.2461 4.18696C13.918 3.51509 13.918 2.42577 13.2461 1.7539C12.5742 1.08203 11.4849 1.08203 10.813 1.7539Z"
          stroke="#1D1D1D"
        />
        <path
          d="M10.4076 2.15942C10.4076 2.15942 10.4583 3.02113 11.2186 3.78146C11.9789 4.54179 12.8406 4.59248 12.8406 4.59248M6.31255 9.74225L5.25781 8.68751"
          stroke="#1D1D1D"
        />
      </g>
      <defs>
        <clipPath id="clip0_625_5516">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  editIconWorkflow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
        stroke="#185CB7"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M13 4L20 11"
        stroke="#185CB7"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M14 22L22 22"
        stroke="#185CB7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  delteIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33398 10V14.1667"
        stroke="#1C274C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 10V14.1667"
        stroke="#1C274C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 5.83301H16.6673"
        stroke="#1C274C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.33301V14.9997C5 16.3804 6.11929 17.4997 7.5 17.4997H12.5C13.8807 17.4997 15 16.3804 15 14.9997V8.33301"
        stroke="#1C274C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H10.8333C11.7538 2.5 12.5 3.24619 12.5 4.16667V5.83333H7.5V4.16667Z"
        stroke="#1C274C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  expireIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.54785 6.45463C5.15696 3.60734 5.96152 2.18369 7.06555 1.81722C7.67291 1.61561 8.32717 1.61561 8.93453 1.81722C10.0386 2.18369 10.8431 3.60734 12.4522 6.45463C14.0614 9.30193 14.8659 10.7256 14.6246 11.8856C14.4918 12.5237 14.1647 13.1026 13.6901 13.5391C12.8274 14.3327 11.2183 14.3327 8.00004 14.3327C4.78181 14.3327 3.17269 14.3327 2.31002 13.5391C1.83543 13.1026 1.5083 12.5237 1.37552 11.8856C1.13417 10.7256 1.93873 9.30193 3.54785 6.45463Z"
        stroke="#1D1D1D"
      />
      <path
        d="M7.99474 10.666H8.00073"
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.66602L8 5.99935"
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  downloadIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00024 14L3.23409 14.6626C4.14424 17.2413 4.59932 18.5307 5.63766 19.2654C6.676 20 8.04334 20 10.778 20H13.2225C15.9571 20 17.3245 20 18.3628 19.2654C19.4012 18.5307 19.8562 17.2413 20.7664 14.6626L21.0002 14"
        stroke="#1C5DBC"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.0002 14V4M12.0002 14C11.3 14 9.99177 12.0057 9.50024 11.5M12.0002 14C12.7005 14 14.0087 12.0057 14.5002 11.5"
        stroke="#1C5DBC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  eyeIcon: (
    <svg
      width="18"
      height="14"
      viewBox="0 0 27 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.589 8.99922C17.589 11.0894 15.8768 12.7992 13.7457 12.7992C11.6146 12.7992 9.90234 11.0894 9.90234 8.99922C9.90234 6.90899 11.6146 5.19922 13.7457 5.19922C15.8768 5.19922 17.589 6.90899 17.589 8.99922Z"
        stroke="#1C5DBC"
        strokeWidth="2"
      />
      <path
        d="M25.0409 7.92117C25.4301 8.4059 25.6246 8.64826 25.6246 9C25.6246 9.35174 25.4301 9.5941 25.0409 10.0788C23.2879 12.2624 18.8916 17 13.7455 17C8.59941 17 4.20312 12.2624 2.45011 10.0788C2.06097 9.5941 1.8664 9.35174 1.8664 9C1.8664 8.64826 2.06097 8.4059 2.45011 7.92117C4.20312 5.73755 8.59941 1 13.7455 1C18.8916 1 23.2879 5.73755 25.0409 7.92117Z"
        stroke="#1C5DBC"
        strokeWidth="2"
      />
    </svg>
  ),

  moreIcon: (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2ZM4 9C4 10.1046 3.10457 11 2 11C0.895431 11 0 10.1046 0 9C0 7.89543 0.895431 7 2 7C3.10457 7 4 7.89543 4 9ZM2 18C3.10457 18 4 17.1046 4 16C4 14.8954 3.10457 14 2 14C0.895431 14 0 14.8954 0 16C0 17.1046 0.895431 18 2 18Z"
        fill="#222222"
      />
    </svg>
  ),

  profileIcon: (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8424 23.4217C18.9086 23.7033 17.8049 23.8333 16.5102 23.8333H10.1429C8.84816 23.8333 7.74449 23.7033 6.81061 23.4217C7.04408 20.605 9.87755 18.3841 13.3265 18.3841C16.7755 18.3841 19.609 20.605 19.8424 23.4217Z"
        stroke="#171717"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.71423 14.0183V16.25C2.71423 20.345 3.92403 22.5875 6.81056 23.4217C7.04403 20.605 9.8775 18.3841 13.3265 18.3841C16.7755 18.3841 19.6089 20.605 19.8424 23.4217C22.7289 22.5875 23.9387 20.345 23.9387 16.25V9.75001C23.9387 4.33334 21.8163 2.16667 16.5102 2.16667H10.1428C4.83668 2.16667 2.71423 4.33334 2.71423 9.75001V14.0183ZM13.3265 15.3508C11.2253 15.3508 9.52729 13.6067 9.52729 11.4617C9.52729 9.31669 11.2253 7.58334 13.3265 7.58334C15.4277 7.58334 17.1257 9.31669 17.1257 11.4617C17.1257 13.6067 15.4277 15.3508 13.3265 15.3508Z"
        stroke="#171717"
        strokeWidth="1.89583"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1257 11.4617C17.1257 13.6067 15.4278 15.3508 13.3265 15.3508C11.2253 15.3508 9.52734 13.6067 9.52734 11.4617C9.52734 9.31668 11.2253 7.58333 13.3265 7.58333C15.4278 7.58333 17.1257 9.31668 17.1257 11.4617Z"
        stroke="#171717"
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

    editIconBlue: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_540_3866)">
    <path d="M16.5 7.875V9C16.5 12.5355 16.5 14.3033 15.4017 15.4017C14.3033 16.5 12.5355 16.5 9 16.5C5.46447 16.5 3.6967 16.5 2.59835 15.4017C1.5 14.3033 1.5 12.5355 1.5 9C1.5 5.46447 1.5 3.6967 2.59835 2.59835C3.6967 1.5 5.46447 1.5 9 1.5H10.125" stroke="#185CB7" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12.9756 2.10468L12.489 2.5913L8.01538 7.06495C7.71237 7.36796 7.56087 7.51946 7.43057 7.68651C7.27687 7.88357 7.1451 8.09679 7.03758 8.32239C6.94644 8.51363 6.87868 8.7169 6.74317 9.12343L6.30931 10.425L6.02859 11.2672C5.9619 11.4672 6.01397 11.6878 6.16308 11.8369C6.3122 11.986 6.53276 12.0381 6.73282 11.9714L7.575 11.6907L8.87657 11.2568L8.87658 11.2568C9.2831 11.1213 9.48637 11.0536 9.67761 10.9624C9.90321 10.8549 10.1164 10.7231 10.3135 10.5694C10.4805 10.4391 10.632 10.2876 10.9351 9.98462L15.4087 5.51097L15.8953 5.02435C16.7016 4.21811 16.7016 2.91093 15.8953 2.10468C15.0891 1.29844 13.7819 1.29844 12.9756 2.10468Z" stroke="#185CB7" strokeWidth="1.5"/>
    <path d="M12.4922 2.5918C12.4922 2.5918 12.553 3.62585 13.4654 4.53824C14.3778 5.45064 15.4119 5.51147 15.4119 5.51147M7.57819 11.6912L6.3125 10.4255" stroke="#185CB7" strokeWidth="1.5"/>
    </g>
    <defs>
    <clipPath id="clip0_540_3866">
    <rect width="18" height="18" fill="white"/>
    </clipPath>
    </defs>
    </svg>,
    
    deleteIconRed: <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.37109 11.5V16.8241" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.6289 11.5V16.8241" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.98047 6.17578H20.0175" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.10938 9.37109V17.8896C5.10938 19.6539 6.53958 21.0841 8.30382 21.0841H14.6927C16.457 21.0841 17.8872 19.6539 17.8872 17.8896V9.37109" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.30469 4.04565C8.30469 2.86948 9.25815 1.91602 10.4343 1.91602H12.5639C13.7401 1.91602 14.6936 2.86948 14.6936 4.04565V6.17527H8.30469V4.04565Z" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,

    deleteIconRed18: <svg width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.37109 11.5V16.8241" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.6289 11.5V16.8241" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.98047 6.17578H20.0175" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.10938 9.37109V17.8896C5.10938 19.6539 6.53958 21.0841 8.30382 21.0841H14.6927C16.457 21.0841 17.8872 19.6539 17.8872 17.8896V9.37109" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.30469 4.04565C8.30469 2.86948 9.25815 1.91602 10.4343 1.91602H12.5639C13.7401 1.91602 14.6936 2.86948 14.6936 4.04565V6.17527H8.30469V4.04565Z" stroke="#F85555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    
    profileActiveIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.14 21.6207C17.26 21.8807 16.22 22.0007 15 22.0007H8.99998C7.77998 22.0007 6.73999 21.8807 5.85999 21.6207C6.07999 19.0207 8.74998 16.9707 12 16.9707C15.25 16.9707 17.92 19.0207 18.14 21.6207Z" stroke="#185CB7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 12.94V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V12.94ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z" stroke="#185CB7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.58 10.58C15.58 12.56 13.98 14.17 12 14.17C10.02 14.17 8.41998 12.56 8.41998 10.58C8.41998 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58Z" stroke="#185CB7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    
    creditIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" stroke="#1D1D1D" strokeWidth="1.5"/>
    <path d="M11.4697 6.99138C11.7626 6.69849 12.2375 6.69849 12.5304 6.99138L17.009 11.4701C17.3019 11.763 17.3019 12.2378 17.009 12.5307L12.5304 17.0094C12.2375 17.3023 11.7626 17.3023 11.4697 17.0094L6.99102 12.5307C6.69812 12.2378 6.69812 11.763 6.99101 11.4701L11.4697 6.99138Z" stroke="black" strokeWidth="1.5"/>
    </svg>,    
    
    addMoreIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8V16M16 12L8 12" stroke="#2A67C1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z" stroke="#2A67C1" strokeWidth="2"/>
    </svg>,
  PasswordIcon: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 18.5625V16.3125"
        stroke="#1C274C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4.80129 21.2003C5.05428 23.0794 6.61065 24.5515 8.50461 24.6385C10.0983 24.7118 11.7172 24.75 13.5 24.75C15.2828 24.75 16.9017 24.7118 18.4954 24.6385C20.3894 24.5515 21.9457 23.0794 22.1987 21.2003C22.3638 19.974 22.5 18.7173 22.5 17.4375C22.5 16.1577 22.3638 14.901 22.1987 13.6747C21.9457 11.7956 20.3894 10.3236 18.4954 10.2365C16.9017 10.1632 15.2828 10.125 13.5 10.125C11.7172 10.125 10.0983 10.1632 8.50461 10.2365C6.61064 10.3236 5.05428 11.7956 4.80129 13.6747C4.63617 14.901 4.5 16.1577 4.5 17.4375C4.5 18.7173 4.63617 19.974 4.80129 21.2003Z"
        stroke="#1C274C"
        strokeWidth="2"
      />
      <path
        d="M8.4375 10.125V7.3125C8.4375 4.51656 10.7041 2.25 13.5 2.25C16.2959 2.25 18.5625 4.51656 18.5625 7.3125V10.125"
        stroke="#1C274C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  HelpSupportIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="#141B34"
        strokeWidth="1.7"
      />
      <path
        d="M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 9.39815 13.8837 9.76913 13.6831 10.0808C13.0854 11.0097 12 11.8954 12 13V13.5"
        stroke="#141B34"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M11.992 17H12.001"
        stroke="#141B34"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  logoutIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.987 10.2401 20.8194 9.05112 20.484C6.18961 19.6768 3.70555 18.3203 3.10956 15.2815C3 14.723 3 14.0944 3 12.8373L3 11.1627C3 9.90561 3 9.27705 3.10956 8.71846C3.70555 5.67965 6.18961 4.32316 9.05112 3.51603C10.2401 3.18064 10.8346 3.01295 11.3156 3.00119C13.3831 2.95061 14.9264 4.52307 15 6.37501"
        stroke="#F8363A"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
        stroke="#F8363A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  profileShowIcon: (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke="#1D1D1D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  fullviewIcon: (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8253 7.17474L14.3556 6.64441L14.3556 6.64441L13.8253 7.17474ZM11.2159 6.25C10.8017 6.25 10.4659 6.58579 10.4659 7C10.4659 7.41421 10.8017 7.75 11.2159 7.75V6.25ZM13.25 9.78409C13.25 10.1983 13.5858 10.5341 14 10.5341C14.4142 10.5341 14.75 10.1983 14.75 9.78409H13.25ZM8.65717 11.2822C8.36428 11.5751 8.36428 12.0499 8.65717 12.3428C8.95006 12.6357 9.42494 12.6357 9.71783 12.3428L8.65717 11.2822ZM11.2159 7.75H12.8068V6.25H11.2159V7.75ZM13.25 8.19318V9.78409H14.75V8.19318H13.25ZM12.8068 7.75C12.9502 7.75 13.063 7.75005 13.1597 7.75249C13.2569 7.75494 13.3194 7.75949 13.3615 7.76515C13.4408 7.77582 13.3701 7.78028 13.2949 7.70507L14.3556 6.64441C14.1056 6.39446 13.807 6.31155 13.5614 6.27853C13.3373 6.24841 13.0669 6.25 12.8068 6.25V7.75ZM14.75 8.19318C14.75 7.93315 14.7516 7.66267 14.7215 7.43862C14.6884 7.193 14.6055 6.89435 14.3556 6.64441L13.2949 7.70507C13.2197 7.62986 13.2242 7.5592 13.2348 7.6385C13.2405 7.68061 13.2451 7.74308 13.2475 7.84025C13.25 7.93704 13.25 8.04978 13.25 8.19318H14.75ZM13.2949 6.64441L8.65717 11.2822L9.71783 12.3428L14.3556 7.70507L13.2949 6.64441Z"
        fill="white"
      />
      <path
        d="M1.75 14.875C1.75 13.2251 1.75 12.4001 2.26256 11.8876C2.77513 11.375 3.60008 11.375 5.25 11.375H6.125C7.77492 11.375 8.59987 11.375 9.11244 11.8876C9.625 12.4001 9.625 13.2251 9.625 14.875V15.75C9.625 17.3999 9.625 18.2249 9.11244 18.7374C8.59987 19.25 7.77492 19.25 6.125 19.25H5.25C3.60008 19.25 2.77513 19.25 2.26256 18.7374C1.75 18.2249 1.75 17.3999 1.75 15.75V14.875Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 7.4375V9.1875M12.25 1.75H8.75M19.25 12.25L19.25 8.75M11.8125 19.25H13.5625M1.80237 4.8125C1.93714 3.88011 2.19928 3.21916 2.70922 2.70922C3.21916 2.19928 3.88011 1.93714 4.8125 1.80237M16.1875 1.80237C17.1199 1.93714 17.7808 2.19928 18.2908 2.70922C18.8007 3.21916 19.0629 3.88011 19.1976 4.8125M19.1976 16.1875C19.0629 17.1199 18.8007 17.7808 18.2908 18.2908C17.7808 18.8007 17.1199 19.0629 16.1875 19.1976"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),

  deleteMinusIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9L6 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 9C1.875 5.64124 1.875 3.96186 2.91843 2.91843C3.96186 1.875 5.64124 1.875 9 1.875C12.3588 1.875 14.0381 1.875 15.0816 2.91843C16.125 3.96186 16.125 5.64124 16.125 9C16.125 12.3588 16.125 14.0381 15.0816 15.0816C14.0381 16.125 12.3588 16.125 9 16.125C5.64124 16.125 3.96186 16.125 2.91843 15.0816C1.875 14.0381 1.875 12.3588 1.875 9Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),

  notificationIcon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9988 12.9461V12.0066C24.9988 6.84833 20.9699 2.66669 16 2.66669C11.0301 2.66669 7.00116 6.84833 7.00116 12.0066V12.9461C7.00116 14.0736 6.67962 15.1758 6.07706 16.1139L4.60048 18.4127C3.25176 20.5125 4.2814 23.3666 6.62715 24.0306C12.7637 25.7676 19.2363 25.7676 25.3729 24.0306C27.7186 23.3666 28.7482 20.5125 27.3995 18.4127L25.9229 16.1139C25.3204 15.1758 24.9988 14.0736 24.9988 12.9461Z"
        stroke="#363432"
        strokeWidth="2"
      />
      <path
        d="M10 25.3333C10.8734 27.6637 13.2299 29.3333 16 29.3333C18.7701 29.3333 21.1266 27.6637 22 25.3333"
        stroke="#363432"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  clockIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_798_22125)">
        <circle
          cx="10.0013"
          cy="9.99996"
          r="8.33333"
          stroke="#141B34"
          strokeWidth="1.5"
        />
        <path
          d="M10 6.66663V9.99996L11.6667 11.6666"
          stroke="#141B34"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_798_22125">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  alertIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1999_12626)">
        <circle
          cx="9.99935"
          cy="9.99996"
          r="8.33333"
          fill="#EA464A"
          stroke="#EA464A"
          strokeWidth="1.5"
        />
        <path
          d="M9.99203 12.5H9.99951"
          stroke="#F9F9F9"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L10 6.66667"
          stroke="#F9F9F9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1999_12626">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  searchIcon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3958 12.8945L15.5833 16.082"
        stroke="#8D8D8D"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 8.29102C14.1667 4.7702 11.3125 1.91602 7.79169 1.91602C4.27087 1.91602 1.41669 4.7702 1.41669 8.29102C1.41669 11.8118 4.27087 14.666 7.79169 14.666C11.3125 14.666 14.1667 11.8118 14.1667 8.29102Z"
        stroke="#8D8D8D"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  ),

  signersIcon: (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_525_3969)">
        <ellipse
          cx="10"
          cy="4.95669"
          rx="3.33333"
          ry="3.30435"
          stroke="#1D1D1D"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M15 7.43512C16.3807 7.43512 17.5 6.51049 17.5 5.3699C17.5 4.22932 16.3807 3.30469 15 3.30469"
          stroke="#1D1D1D"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M5 7.43512C3.61929 7.43512 2.5 6.51049 2.5 5.3699C2.5 4.22932 3.61929 3.30469 5 3.30469"
          stroke="#1D1D1D"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <ellipse
          cx="10"
          cy="14.0426"
          rx="5"
          ry="3.30435"
          stroke="#1D1D1D"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M16.6667 15.6949C18.1286 15.3771 19.1667 14.5723 19.1667 13.6297C19.1667 12.6871 18.1286 11.8822 16.6667 11.5645"
          stroke="#1D1D1D"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          opacity="0.5"
          d="M3.33331 15.6949C1.87144 15.3771 0.833313 14.5723 0.833313 13.6297C0.833313 12.6871 1.87144 11.8822 3.33331 11.5645"
          stroke="#1D1D1D"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_525_3969">
          <rect width="20" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  refreshIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4840_5963)">
        <path
          d="M15.0069 1.5V3.84914C15.0069 4.06954 14.7314 4.16931 14.5903 4C13.217 2.46563 11.2212 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9"
          stroke="#1D1D1D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4840_5963">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  sendReminder: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="13"
        r="9"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M5 19L3 21M19 19L21 21"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 3.5697L19.5955 3.27195C20.4408 2.84932 20.7583 2.89769 21.4303 3.5697C22.1023 4.2417 22.1507 4.55924 21.728 5.4045L21.4303 6M5 3.5697L4.4045 3.27195C3.55924 2.84932 3.2417 2.89769 2.5697 3.5697C1.89769 4.2417 1.84932 4.55924 2.27195 5.4045L2.5697 6"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12 9.5V13.5L14 15.5"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 3.5V2"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 2H14"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  fileUploadIcon: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.10425 17.416H8.88834C6.30655 17.416 5.01566 17.416 4.11918 16.7844C3.86232 16.6034 3.63429 16.3888 3.44201 16.1471C2.77092 15.3033 2.77092 14.0884 2.77092 11.6584V9.64329C2.77092 7.29744 2.77092 6.12452 3.14216 5.18774C3.73898 3.68173 5.00115 2.4938 6.60128 1.93209C7.59662 1.58268 8.84285 1.58268 11.3353 1.58268C12.7596 1.58268 13.4717 1.58268 14.0405 1.78234C14.9548 2.10332 15.6761 2.78214 16.0171 3.64271C16.2292 4.17802 16.2292 4.84826 16.2292 6.18874V9.49935"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77083 9.5C2.77083 8.04258 3.9523 6.86111 5.40972 6.86111C5.9368 6.86111 6.5582 6.95347 7.07066 6.81615C7.52599 6.69415 7.88165 6.33849 8.00365 5.88316C8.14097 5.3707 8.04861 4.7493 8.04861 4.22222C8.04861 2.7648 9.23008 1.58333 10.6875 1.58333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4375 13.0612C15.0484 12.6609 14.0127 11.082 13.4583 11.082M11.4792 13.0612C11.8683 12.6609 12.904 11.082 13.4583 11.082M13.4583 11.082V17.4154"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  editIconBlue: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_540_3866)">
        <path
          d="M16.5 7.875V9C16.5 12.5355 16.5 14.3033 15.4017 15.4017C14.3033 16.5 12.5355 16.5 9 16.5C5.46447 16.5 3.6967 16.5 2.59835 15.4017C1.5 14.3033 1.5 12.5355 1.5 9C1.5 5.46447 1.5 3.6967 2.59835 2.59835C3.6967 1.5 5.46447 1.5 9 1.5H10.125"
          stroke="#185CB7"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12.9756 2.10468L12.489 2.5913L8.01538 7.06495C7.71237 7.36796 7.56087 7.51946 7.43057 7.68651C7.27687 7.88357 7.1451 8.09679 7.03758 8.32239C6.94644 8.51363 6.87868 8.7169 6.74317 9.12343L6.30931 10.425L6.02859 11.2672C5.9619 11.4672 6.01397 11.6878 6.16308 11.8369C6.3122 11.986 6.53276 12.0381 6.73282 11.9714L7.575 11.6907L8.87657 11.2568L8.87658 11.2568C9.2831 11.1213 9.48637 11.0536 9.67761 10.9624C9.90321 10.8549 10.1164 10.7231 10.3135 10.5694C10.4805 10.4391 10.632 10.2876 10.9351 9.98462L15.4087 5.51097L15.8953 5.02435C16.7016 4.21811 16.7016 2.91093 15.8953 2.10468C15.0891 1.29844 13.7819 1.29844 12.9756 2.10468Z"
          stroke="#185CB7"
          strokeWidth="1.5"
        />
        <path
          d="M12.4922 2.5918C12.4922 2.5918 12.553 3.62585 13.4654 4.53824C14.3778 5.45064 15.4119 5.51147 15.4119 5.51147M7.57819 11.6912L6.3125 10.4255"
          stroke="#185CB7"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_540_3866">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  deleteIconRed: (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37109 11.5V16.8241"
        stroke="#F85555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6289 11.5V16.8241"
        stroke="#F85555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98047 6.17578H20.0175"
        stroke="#F85555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.10938 9.37109V17.8896C5.10938 19.6539 6.53958 21.0841 8.30382 21.0841H14.6927C16.457 21.0841 17.8872 19.6539 17.8872 17.8896V9.37109"
        stroke="#F85555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.30469 4.04565C8.30469 2.86948 9.25815 1.91602 10.4343 1.91602H12.5639C13.7401 1.91602 14.6936 2.86948 14.6936 4.04565V6.17527H8.30469V4.04565Z"
        stroke="#F85555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  profileActiveIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.14 21.6207C17.26 21.8807 16.22 22.0007 15 22.0007H8.99998C7.77998 22.0007 6.73999 21.8807 5.85999 21.6207C6.07999 19.0207 8.74998 16.9707 12 16.9707C15.25 16.9707 17.92 19.0207 18.14 21.6207Z"
        stroke="#185CB7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.94V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V12.94ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z"
        stroke="#185CB7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.58 10.58C15.58 12.56 13.98 14.17 12 14.17C10.02 14.17 8.41998 12.56 8.41998 10.58C8.41998 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58Z"
        stroke="#185CB7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  creditIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
        stroke="#1D1D1D"
        strokeWidth="1.5"
      />
      <path
        d="M11.4697 6.99138C11.7626 6.69849 12.2375 6.69849 12.5304 6.99138L17.009 11.4701C17.3019 11.763 17.3019 12.2378 17.009 12.5307L12.5304 17.0094C12.2375 17.3023 11.7626 17.3023 11.4697 17.0094L6.99102 12.5307C6.69812 12.2378 6.69812 11.763 6.99101 11.4701L11.4697 6.99138Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),

  addMoreIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8V16M16 12L8 12"
        stroke="#2A67C1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="#2A67C1"
        strokeWidth="2"
      />
    </svg>
  ),

  eyeBlueIcon: (
    <svg
      width="26"
      height="18"
      viewBox="0 0 26 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9523 8.99922C16.9523 11.0894 15.24 12.7992 13.1089 12.7992C10.9778 12.7992 9.26562 11.0894 9.26562 8.99922C9.26562 6.90899 10.9778 5.19922 13.1089 5.19922C15.24 5.19922 16.9523 6.90899 16.9523 8.99922Z"
        stroke="#1C5DBC"
        strokeWidth="2"
      />
      <path
        d="M24.4037 7.92117C24.7928 8.4059 24.9874 8.64826 24.9874 9C24.9874 9.35174 24.7928 9.5941 24.4037 10.0788C22.6507 12.2624 18.2544 17 13.1083 17C7.9622 17 3.56591 12.2624 1.8129 10.0788C1.42376 9.5941 1.22919 9.35174 1.22919 9C1.22919 8.64826 1.42376 8.4059 1.8129 7.92117C3.56591 5.73755 7.9622 1 13.1083 1C18.2544 1 22.6507 5.73755 24.4037 7.92117Z"
        stroke="#1C5DBC"
        strokeWidth="2"
      />
    </svg>
  ),

  listViewIconActive: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33203 4.875L21.6654 4.875"
        stroke="#1C5DBC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 15.709L21.6654 15.709"
        stroke="#1C5DBC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 10.291L21.6654 10.291"
        stroke="#1C5DBC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 21.125L21.6654 21.125"
        stroke="#1C5DBC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  listViewIcon: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33203 4.875L21.6654 4.875"
        stroke="#1D1D1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 15.709L21.6654 15.709"
        stroke="#1D1D1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 10.291L21.6654 10.291"
        stroke="#1D1D1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33203 21.125L21.6654 21.125"
        stroke="#1D1D1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  tileViewIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 18C2 16.4596 2 15.6893 2.34673 15.1235C2.54074 14.8069 2.80693 14.5407 3.12353 14.3467C3.68934 14 4.45956 14 6 14C7.54044 14 8.31066 14 8.87647 14.3467C9.19307 14.5407 9.45926 14.8069 9.65327 15.1235C10 15.6893 10 16.4596 10 18C10 19.5404 10 20.3107 9.65327 20.8765C9.45926 21.1931 9.19307 21.4593 8.87647 21.6533C8.31066 22 7.54044 22 6 22C4.45956 22 3.68934 22 3.12353 21.6533C2.80693 21.4593 2.54074 21.1931 2.34673 20.8765C2 20.3107 2 19.5404 2 18Z"
        stroke="#1D1D1D"
        strokeWidth="1.5"
      />
      <path
        d="M14 18C14 16.4596 14 15.6893 14.3467 15.1235C14.5407 14.8069 14.8069 14.5407 15.1235 14.3467C15.6893 14 16.4596 14 18 14C19.5404 14 20.3107 14 20.8765 14.3467C21.1931 14.5407 21.4593 14.8069 21.6533 15.1235C22 15.6893 22 16.4596 22 18C22 19.5404 22 20.3107 21.6533 20.8765C21.4593 21.1931 21.1931 21.4593 20.8765 21.6533C20.3107 22 19.5404 22 18 22C16.4596 22 15.6893 22 15.1235 21.6533C14.8069 21.4593 14.5407 21.1931 14.3467 20.8765C14 20.3107 14 19.5404 14 18Z"
        stroke="#1D1D1D"
        strokeWidth="1.5"
      />
      <path
        d="M2 6C2 4.45956 2 3.68934 2.34673 3.12353C2.54074 2.80693 2.80693 2.54074 3.12353 2.34673C3.68934 2 4.45956 2 6 2C7.54044 2 8.31066 2 8.87647 2.34673C9.19307 2.54074 9.45926 2.80693 9.65327 3.12353C10 3.68934 10 4.45956 10 6C10 7.54044 10 8.31066 9.65327 8.87647C9.45926 9.19307 9.19307 9.45926 8.87647 9.65327C8.31066 10 7.54044 10 6 10C4.45956 10 3.68934 10 3.12353 9.65327C2.80693 9.45926 2.54074 9.19307 2.34673 8.87647C2 8.31066 2 7.54044 2 6Z"
        stroke="#1D1D1D"
        strokeWidth="1.5"
      />
      <path
        d="M14 6C14 4.45956 14 3.68934 14.3467 3.12353C14.5407 2.80693 14.8069 2.54074 15.1235 2.34673C15.6893 2 16.4596 2 18 2C19.5404 2 20.3107 2 20.8765 2.34673C21.1931 2.54074 21.4593 2.80693 21.6533 3.12353C22 3.68934 22 4.45956 22 6C22 7.54044 22 8.31066 21.6533 8.87647C21.4593 9.19307 21.1931 9.45926 20.8765 9.65327C20.3107 10 19.5404 10 18 10C16.4596 10 15.6893 10 15.1235 9.65327C14.8069 9.45926 14.5407 9.19307 14.3467 8.87647C14 8.31066 14 7.54044 14 6Z"
        stroke="#1D1D1D"
        strokeWidth="1.5"
      />
    </svg>
  ),

  tileViewIconActive: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 18C2 16.4596 2 15.6893 2.34673 15.1235C2.54074 14.8069 2.80693 14.5407 3.12353 14.3467C3.68934 14 4.45956 14 6 14C7.54044 14 8.31066 14 8.87647 14.3467C9.19307 14.5407 9.45926 14.8069 9.65327 15.1235C10 15.6893 10 16.4596 10 18C10 19.5404 10 20.3107 9.65327 20.8765C9.45926 21.1931 9.19307 21.4593 8.87647 21.6533C8.31066 22 7.54044 22 6 22C4.45956 22 3.68934 22 3.12353 21.6533C2.80693 21.4593 2.54074 21.1931 2.34673 20.8765C2 20.3107 2 19.5404 2 18Z"
        stroke="#1C5DBC"
        strokeWidth="1.5"
      />
      <path
        d="M14 18C14 16.4596 14 15.6893 14.3467 15.1235C14.5407 14.8069 14.8069 14.5407 15.1235 14.3467C15.6893 14 16.4596 14 18 14C19.5404 14 20.3107 14 20.8765 14.3467C21.1931 14.5407 21.4593 14.8069 21.6533 15.1235C22 15.6893 22 16.4596 22 18C22 19.5404 22 20.3107 21.6533 20.8765C21.4593 21.1931 21.1931 21.4593 20.8765 21.6533C20.3107 22 19.5404 22 18 22C16.4596 22 15.6893 22 15.1235 21.6533C14.8069 21.4593 14.5407 21.1931 14.3467 20.8765C14 20.3107 14 19.5404 14 18Z"
        stroke="#1C5DBC"
        strokeWidth="1.5"
      />
      <path
        d="M2 6C2 4.45956 2 3.68934 2.34673 3.12353C2.54074 2.80693 2.80693 2.54074 3.12353 2.34673C3.68934 2 4.45956 2 6 2C7.54044 2 8.31066 2 8.87647 2.34673C9.19307 2.54074 9.45926 2.80693 9.65327 3.12353C10 3.68934 10 4.45956 10 6C10 7.54044 10 8.31066 9.65327 8.87647C9.45926 9.19307 9.19307 9.45926 8.87647 9.65327C8.31066 10 7.54044 10 6 10C4.45956 10 3.68934 10 3.12353 9.65327C2.80693 9.45926 2.54074 9.19307 2.34673 8.87647C2 8.31066 2 7.54044 2 6Z"
        stroke="#1C5DBC"
        strokeWidth="1.5"
      />
      <path
        d="M14 6C14 4.45956 14 3.68934 14.3467 3.12353C14.5407 2.80693 14.8069 2.54074 15.1235 2.34673C15.6893 2 16.4596 2 18 2C19.5404 2 20.3107 2 20.8765 2.34673C21.1931 2.54074 21.4593 2.80693 21.6533 3.12353C22 3.68934 22 4.45956 22 6C22 7.54044 22 8.31066 21.6533 8.87647C21.4593 9.19307 21.1931 9.45926 20.8765 9.65327C20.3107 10 19.5404 10 18 10C16.4596 10 15.6893 10 15.1235 9.65327C14.8069 9.45926 14.5407 9.19307 14.3467 8.87647C14 8.31066 14 7.54044 14 6Z"
        stroke="#1C5DBC"
        strokeWidth="1.5"
      />
    </svg>
  ),

  crossIcon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H0V0Z"
        fill="white"
      />
      <path
        d="M17.7071 16.2929C17.3166 15.9024 16.6834 15.9024 16.2929 16.2929C15.9024 16.6834 15.9024 17.3166 16.2929 17.7071L17.7071 16.2929ZM23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L23.2929 24.7071ZM16.2929 23.2929C15.9024 23.6834 15.9024 24.3166 16.2929 24.7071C16.6834 25.0976 17.3166 25.0976 17.7071 24.7071L16.2929 23.2929ZM24.7071 17.7071C25.0976 17.3166 25.0976 16.6834 24.7071 16.2929C24.3166 15.9024 23.6834 15.9024 23.2929 16.2929L24.7071 17.7071ZM16.2929 17.7071L19.7929 21.2071L21.2071 19.7929L17.7071 16.2929L16.2929 17.7071ZM19.7929 21.2071L23.2929 24.7071L24.7071 23.2929L21.2071 19.7929L19.7929 21.2071ZM17.7071 24.7071L21.2071 21.2071L19.7929 19.7929L16.2929 23.2929L17.7071 24.7071ZM21.2071 21.2071L24.7071 17.7071L23.2929 16.2929L19.7929 19.7929L21.2071 21.2071Z"
        fill="#185CB7"
      />
    </svg>
  ),

  notificationTextIcon: (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1888_12171)">
        <path
          d="M21.0218 14.2218L21.2031 13.6025C22.1985 10.2019 20.3494 6.66779 17.073 5.70875C13.7966 4.74971 10.3337 6.72896 9.33828 10.1295L9.15699 10.7489C8.93943 11.4921 8.51476 12.1567 7.93651 12.6589L6.51948 13.8894C5.22517 15.0134 5.35319 17.0936 6.77148 17.984C10.4817 20.3133 14.7488 21.5623 19.1294 21.6013C20.8039 21.6163 22.0335 19.9334 21.5495 18.2889L21.0197 16.4885C20.8035 15.7538 20.8042 14.9651 21.0218 14.2218Z"
          stroke="url(#paint0_linear_1888_12171)"
          strokeWidth="1.5"
        />
        <path
          d="M8.74361 19.4937C8.86968 21.1985 10.101 22.754 11.9272 23.2885C13.7533 23.823 15.629 23.1771 16.6545 21.8093"
          stroke="url(#paint1_linear_1888_12171)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1888_12171"
          x1="17.073"
          y1="5.70875"
          x2="12.699"
          y2="20.6515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2954A6" />
          <stop offset="1" stop-color="#A5172D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1888_12171"
          x1="11.9272"
          y1="23.2885"
          x2="12.6991"
          y2="20.6515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2954A6" />
          <stop offset="1" stop-color="#A5172D" />
        </linearGradient>
        <clipPath id="clip0_1888_12171">
          <rect
            x="7.03973"
            y="0.863281"
            width="21.9808"
            height="21.9808"
            rx="5"
            transform="rotate(16.3155 7.03973 0.863281)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  copyIcon: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.625 0.884766H7.7517C6.44996 0.884755 5.41888 0.884746 4.61194 0.993237C3.78148 1.10489 3.1093 1.34014 2.57921 1.87023C2.04912 2.40032 1.81387 3.07249 1.70222 3.90296C1.59373 4.7099 1.59374 5.74097 1.59375 7.04271V11.3327C1.59375 12.6589 2.56562 13.758 3.83599 13.9569C3.93372 14.498 4.12075 14.9599 4.49675 15.3359C4.92311 15.7623 5.45993 15.9457 6.09751 16.0314C6.71161 16.114 7.49242 16.1139 8.46113 16.1139H10.6639C11.6326 16.1139 12.4134 16.114 13.0275 16.0314C13.6651 15.9457 14.2019 15.7623 14.6283 15.3359C15.0546 14.9096 15.238 14.3728 15.3237 13.7352C15.4063 13.1211 15.4063 12.3403 15.4063 11.3715V7.75215C15.4063 6.78344 15.4063 6.00263 15.3237 5.38853C15.238 4.75095 15.0546 4.21412 14.6283 3.78776C14.2523 3.41176 13.7903 3.22473 13.2492 3.12701C13.0504 1.85664 11.9512 0.884766 10.625 0.884766ZM12.1333 3.02476C11.9188 2.39793 11.3245 1.94727 10.625 1.94727H7.79167C6.441 1.94727 5.48145 1.94839 4.75352 2.04626C4.04087 2.14207 3.63029 2.32176 3.33052 2.62153C3.03074 2.9213 2.85106 3.33189 2.75525 4.04453C2.65738 4.77246 2.65625 5.73202 2.65625 7.08268V11.3327C2.65625 12.0322 3.10692 12.6265 3.73374 12.841C3.71873 12.4089 3.71874 11.9204 3.71875 11.3716V7.75215C3.71874 6.78344 3.71872 6.00263 3.80129 5.38853C3.88701 4.75095 4.07039 4.21412 4.49675 3.78776C4.92311 3.36141 5.45993 3.17802 6.09751 3.0923C6.71161 3.00974 7.49242 3.00975 8.46113 3.00977H10.6639C11.2127 3.00976 11.7012 3.00975 12.1333 3.02476ZM5.24805 4.53907C5.44409 4.34302 5.71933 4.21521 6.23909 4.14533C6.77413 4.07339 7.48325 4.07227 8.5 4.07227H10.625C11.6418 4.07227 12.3509 4.07339 12.8859 4.14533C13.4057 4.21521 13.6809 4.34302 13.877 4.53907C14.073 4.73511 14.2008 5.01034 14.2707 5.5301C14.3426 6.06514 14.3438 6.77426 14.3438 7.79102V11.3327C14.3438 12.3494 14.3426 13.0586 14.2707 13.5936C14.2008 14.1134 14.073 14.3886 13.877 14.5846C13.6809 14.7807 13.4057 14.9085 12.8859 14.9784C12.3509 15.0503 11.6418 15.0514 10.625 15.0514H8.5C7.48325 15.0514 6.77413 15.0503 6.23909 14.9784C5.71933 14.9085 5.44409 14.7807 5.24805 14.5846C5.05201 14.3886 4.92419 14.1134 4.85431 13.5936C4.78238 13.0586 4.78125 12.3494 4.78125 11.3327V7.79102C4.78125 6.77426 4.78238 6.06514 4.85431 5.5301C4.92419 5.01034 5.05201 4.73511 5.24805 4.53907Z"
        fill="#1D1D1D"
      />
    </svg>
  ),

  filterIcon: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8806 9.29765L13.2616 9.76117L12.8806 9.29765ZM5.84141 9.30662L6.24041 8.85852L5.84141 9.30662ZM10.5826 15.3125L10.2364 14.8225L10.5826 15.3125ZM9.04575 16.3982L9.39195 16.8883H9.39195L9.04575 16.3982ZM3.26644 7.0138L2.86744 7.4619L3.26644 7.0138ZM15.6676 7.00697L15.2866 6.54345L15.6676 7.00697ZM12.6667 6.14167C12.998 6.14167 13.2667 5.87304 13.2667 5.54167C13.2667 5.2103 12.998 4.94167 12.6667 4.94167V6.14167ZM6.33333 4.94167C6.00196 4.94167 5.73333 5.21029 5.73333 5.54167C5.73333 5.87304 6.00196 6.14167 6.33333 6.14167L6.33333 4.94167ZM5.12403 2.975H13.9208V1.775H5.12403V2.975ZM10.2364 14.8225L8.69955 15.9082L9.39195 16.8883L10.9288 15.8026L10.2364 14.8225ZM7.725 15.4481V12.141H6.525V15.4481H7.725ZM6.24041 8.85852L3.66545 6.5657L2.86744 7.4619L5.44241 9.75473L6.24041 8.85852ZM15.2866 6.54345L12.4997 8.83413L13.2616 9.76117L16.0486 7.4705L15.2866 6.54345ZM10.8792 12.2329V13.6022H12.0792V12.2329H10.8792ZM12.4997 8.83413C11.4749 9.67639 10.8792 10.9188 10.8792 12.2329H12.0792C12.0792 11.2849 12.5087 10.3801 13.2616 9.76117L12.4997 8.83413ZM7.725 12.141C7.725 10.8889 7.18382 9.69856 6.24041 8.85852L5.44241 9.75473C6.13481 10.3713 6.525 11.2376 6.525 12.141H7.725ZM10.9288 15.8026C11.6476 15.2948 12.0792 14.4781 12.0792 13.6022H10.8792C10.8792 14.0795 10.6442 14.5344 10.2364 14.8225L10.9288 15.8026ZM8.69955 15.9082C8.27116 16.2108 7.725 15.8896 7.725 15.4481H6.525C6.525 16.9269 8.22157 17.7151 9.39195 16.8883L8.69955 15.9082ZM1.775 5.04534C1.775 5.96819 2.17391 6.84436 2.86744 7.4619L3.66545 6.5657C3.22292 6.17166 2.975 5.61952 2.975 5.04534H1.775ZM16.025 5.00175C16.025 5.59136 15.7579 6.15605 15.2866 6.54345L16.0486 7.4705C16.7917 6.85971 17.225 5.95746 17.225 5.00175H16.025ZM13.9208 2.975C15.0995 2.975 16.025 3.89871 16.025 5.00175H17.225C17.225 3.20336 15.7291 1.775 13.9208 1.775V2.975ZM5.12403 1.775C3.29096 1.775 1.775 3.22288 1.775 5.04534H2.975C2.975 3.91823 3.92061 2.975 5.12403 2.975V1.775ZM12.6667 4.94167L6.33333 4.94167L6.33333 6.14167L12.6667 6.14167V4.94167Z"
        fill="#1D1D1D"
      />
    </svg>
  ),

  sortByIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33337 6.66602H10.8334"
        stroke="#1D1D1D"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M5 10.834H10.8333"
        stroke="#1D1D1D"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M6.66663 15H10.8333"
        stroke="#1D1D1D"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M14.1666 16.6673V3.33398L16.6666 6.66732"
        stroke="#1D1D1D"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  bulkUploadIcon: (
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7656 24.166C15.0959 24.1784 14.0911 24.2295 13.2908 24.4414C9.64836 25.4059 7.15462 28.6705 7.2528 32.3457C7.28124 33.4102 7.68649 34.726 8.497 37.3574C10.4476 43.6903 13.7258 49.1879 21.0696 50.5069C22.4195 50.7493 23.9385 50.7493 26.9766 50.7493L31.0234 50.7493C34.0614 50.7493 35.5805 50.7493 36.9304 50.5069C44.2742 49.1879 47.5524 43.6903 49.503 37.3574C50.3135 34.726 50.7188 33.4102 50.7472 32.3457C50.8454 28.6705 48.3516 25.4059 44.7092 24.4414C43.9089 24.2295 42.9041 24.1784 41.2344 24.166"
        stroke="#141B34"
        stroke-width="4"
        stroke-linecap="round"
      />
      <path
        d="M28.9998 7.25065L28.9998 33.834M28.9998 7.25065C30.1317 7.25065 30.9921 8.3094 32.7129 10.4269L35.0415 13.2923M28.9998 7.25065C27.8679 7.25065 27.0075 8.30939 25.2868 10.4269L22.9582 13.2923"
        stroke="#141B34"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  bulkUploadTextIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1215_9193)">
        <path
          d="M10.8332 2.50193C10.4414 2.5 10.0254 2.5 9.58317 2.5C5.85122 2.5 3.98524 2.5 2.82587 3.65937C1.6665 4.81874 1.6665 6.68471 1.6665 10.4167C1.6665 14.1486 1.6665 16.0146 2.82587 17.174C3.98524 18.3333 5.85122 18.3333 9.58317 18.3333C13.3151 18.3333 15.1811 18.3333 16.3405 17.174C17.4559 16.0586 17.4982 14.2892 17.4998 10.8333"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M1.6665 11.7789C2.18235 11.704 2.70387 11.6669 3.22627 11.6682C5.43622 11.6215 7.59204 12.3101 9.30907 13.6112C10.9015 14.8178 12.0204 16.4784 12.4998 18.3327"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M17.5 14.0789C16.5205 13.5827 15.5073 13.331 14.4885 13.3321C12.9454 13.326 11.4179 13.8932 10 14.9987"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M14.1665 3.74935C14.5761 3.32793 15.6663 1.66602 16.2498 1.66602M18.3332 3.74935C17.9236 3.32793 16.8334 1.66602 16.2498 1.66602M16.2498 1.66602V8.33268"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1215_9193">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  circleCrossIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#000000"
      fill="none"
    >
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9994 15L9 9M9.00064 15L15 9"
        stroke="#141B34"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  refreshIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4840_5963)">
        <path
          d="M15.0069 1.5V3.84914C15.0069 4.06954 14.7314 4.16931 14.5903 4C13.217 2.46563 11.2212 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9"
          stroke="#1D1D1D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4840_5963">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  editBlueIcon: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1785_7935)">
        <path
          d="M15.5827 7.43783V8.50033C15.5827 11.8394 15.5827 13.509 14.5454 14.5463C13.508 15.5837 11.8385 15.5837 8.49935 15.5837C5.16023 15.5837 3.49068 15.5837 2.45335 14.5463C1.41602 13.509 1.41602 11.8394 1.41602 8.50033C1.41602 5.16121 1.41602 3.49165 2.45335 2.45432C3.49068 1.41699 5.16023 1.41699 8.49935 1.41699H9.56185"
          stroke="#185CB7"
          stroke-width="1.41667"
          stroke-linecap="round"
        />
        <path
          d="M12.2541 1.98808L11.7945 2.44766L7.56943 6.67277C7.28326 6.95895 7.14017 7.10204 7.01711 7.25981C6.87195 7.44592 6.7475 7.64729 6.64595 7.86036C6.55987 8.04098 6.49588 8.23295 6.3679 8.6169L5.95814 9.84616L5.69301 10.6416C5.63003 10.8305 5.67921 11.0388 5.82004 11.1796C5.96087 11.3205 6.16918 11.3696 6.35812 11.3067L7.15352 11.0415L8.38278 10.6318L8.38278 10.6318C8.76672 10.5038 8.9587 10.4398 9.13932 10.3537C9.35238 10.2522 9.55375 10.1277 9.73986 9.98256C9.89763 9.85951 10.0407 9.71642 10.3269 9.43025L10.3269 9.43024L14.552 5.20513L15.0116 4.74555C15.773 3.9841 15.773 2.74954 15.0116 1.98808C14.2501 1.22663 13.0156 1.22663 12.2541 1.98808Z"
          stroke="#185CB7"
          stroke-width="1.41667"
        />
        <path
          d="M11.7954 2.44824C11.7954 2.44824 11.8528 3.42484 12.7145 4.28655C13.5763 5.14826 14.5529 5.20571 14.5529 5.20571M7.15436 11.0421L5.95898 9.84674"
          stroke="#185CB7"
          stroke-width="1.41667"
        />
      </g>
      <defs>
        <clipPath id="clip0_1785_7935">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  meonAiAssistant: (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="43.5"
        cy="43.5"
        r="43.5"
        fill="url(#paint0_linear_1979_9031)"
      />
      <path
        d="M43.2559 18.9077C46.6099 30.9088 56.058 40.3588 68.0488 43.6958C56.0158 47.0445 46.5435 56.5497 43.2207 68.6108C39.8661 56.6093 30.4176 47.1589 18.4258 43.8228C30.46 40.4746 39.933 30.9699 43.2559 18.9077Z"
        stroke="url(#paint1_linear_1979_9031)"
        stroke-width="2.60479"
      />
      <path
        d="M43.2393 26.0471C43.2745 35.8175 51.1915 43.7268 60.9521 43.7268C51.1697 43.7268 43.2395 51.6717 43.2393 61.4719C43.2036 51.7019 35.2876 43.7925 25.5273 43.7922C35.3095 43.792 43.2393 35.8474 43.2393 26.0471ZM43.2393 34.3821C43.2393 39.5705 39.0412 43.7776 33.8623 43.7776C39.0297 43.7776 43.2205 47.9644 43.2393 53.137C43.2393 47.9485 47.4382 43.7424 52.6172 43.7424C47.4498 43.7424 43.2579 39.5546 43.2393 34.3821Z"
        fill="url(#paint2_linear_1979_9031)"
      />
      <path
        d="M51.2109 27.0268L51.6547 27.7492L52.3204 28.8051C53.1525 28.5272 56.4808 26.4156 56.4253 26.4712C56.0703 26.9602 55.4268 30.4906 55.1495 32.1948L57.0355 33.8618C57.6125 26.6156 61.3809 19.7288 63.193 17.1912C59.8203 21.9034 53.7996 25.7117 51.2109 27.0268Z"
        fill="url(#paint3_linear_1979_9031)"
      />
      <path
        d="M26.8037 35.5055L27.5208 35.0531L28.5686 34.3749C28.2808 33.5462 26.1295 30.2433 26.1858 30.2981C26.679 30.6472 30.2169 31.2485 31.9242 31.5055L33.5686 29.5996C26.316 29.1093 19.3847 25.4235 16.8255 23.6419C21.5778 26.958 25.4578 32.9327 26.8037 35.5055Z"
        fill="url(#paint4_linear_1979_9031)"
      />
      <path
        d="M34.7129 60.4909L34.2505 59.7803L33.5576 58.7421C32.733 59.0415 29.4607 61.239 29.5147 61.182C29.8569 60.6839 30.4084 57.1379 30.6413 55.4272L28.7125 53.8097C28.3243 61.0684 24.7363 68.051 22.9908 70.6349C26.2398 65.8365 32.1593 61.8729 34.7129 60.4909Z"
        fill="url(#paint5_linear_1979_9031)"
      />
      <path
        d="M60.1292 51.5853L59.4073 52.0299L58.3522 52.6968C58.631 53.5286 60.7463 56.8545 60.6907 56.7991C60.2013 56.4446 56.6701 55.8051 54.9657 55.5297L53.3007 57.4176C60.5475 57.9864 67.4386 61.7471 69.9782 63.5564C65.2622 60.1889 61.4472 54.1726 60.1292 51.5853Z"
        fill="url(#paint6_linear_1979_9031)"
      />
      <circle
        cx="43.2401"
        cy="43.7602"
        r="2.08383"
        fill="url(#paint7_linear_1979_9031)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1979_9031"
          x1="5.20958"
          y1="18.2335"
          x2="79.6665"
          y2="61.7605"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2B54A9" />
          <stop offset="1" stop-color="#A91730" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1979_9031"
          x1="31.2567"
          y1="23.1819"
          x2="61.2118"
          y2="78.1429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1979_9031"
          x1="37.2488"
          y1="37.7686"
          x2="46.3655"
          y2="55.481"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1979_9031"
          x1="52.9957"
          y1="18.9787"
          x2="65.5378"
          y2="29.9387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1979_9031"
          x1="18.7348"
          y1="33.8171"
          x2="29.5442"
          y2="21.1449"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1979_9031"
          x1="33.1381"
          y1="68.5827"
          x2="20.3152"
          y2="57.9526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1979_9031"
          x1="68.1793"
          y1="53.3611"
          x2="57.2333"
          y2="65.9154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1979_9031"
          x1="41.777"
          y1="42.1233"
          x2="44.8816"
          y2="45.8979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  changeStatus: (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.69641 0.557364C9.49337 0.614634 9.32676 0.781236 9.26689 0.992092C9.22784 1.12225 9.22784 1.14568 9.26949 1.29666C9.31375 1.45806 9.32416 1.46847 9.90987 2.06199C10.2353 2.38999 10.5034 2.66853 10.5034 2.67894C10.5034 2.68675 9.28251 2.69977 7.7909 2.70497C5.15389 2.71278 5.06799 2.71539 4.78685 2.76745C4.4198 2.83774 4.32869 2.86116 3.99549 2.9757C2.98025 3.31932 2.05613 4.03519 1.4574 4.93588C1.13201 5.43049 0.869087 6.05004 0.741532 6.62794C0.66604 6.97937 0.606167 7.58851 0.62439 7.83841C0.653024 8.21327 0.692072 8.56469 0.7155 8.65841C0.728516 8.70787 0.76496 8.84844 0.793595 8.97079C0.981023 9.73351 1.42096 10.5249 1.99365 11.1236C2.1967 11.3371 2.27219 11.3761 2.50127 11.3761C2.66267 11.3787 2.70171 11.3683 2.81365 11.3006C2.88914 11.2512 2.96984 11.1731 3.0167 11.0976C3.07917 10.9934 3.09219 10.9492 3.09219 10.7982C3.09219 10.5795 3.05314 10.5014 2.81886 10.2463C2.38673 9.78037 2.05613 9.13999 1.90775 8.47879C1.82965 8.13778 1.82184 7.336 1.89473 6.97937C2.18889 5.5242 3.28222 4.3736 4.71136 4.01436C5.1565 3.90243 5.36475 3.89462 7.98874 3.89462C9.36581 3.89462 10.5034 3.90243 10.5112 3.91024C10.5216 3.92065 10.2639 4.19398 9.94111 4.51678C9.61832 4.83957 9.33718 5.13633 9.31895 5.17277C9.29813 5.20922 9.26949 5.29512 9.25127 5.3602C9.19921 5.57366 9.32676 5.8548 9.53502 5.97975C9.6834 6.06826 9.94371 6.07867 10.0947 6.00318C10.178 5.96153 10.5581 5.59969 11.3702 4.7823C12.4089 3.74103 12.5313 3.60827 12.5703 3.49373C12.6224 3.33234 12.6224 3.25945 12.5677 3.09805C12.5287 2.98351 12.4011 2.84554 11.4041 1.84333C10.7819 1.21857 10.2249 0.682316 10.1546 0.638062C10.0218 0.554761 9.82917 0.52092 9.69641 0.557364Z"
        fill="#1D1D1D"
      />
      <path
        d="M15.0922 4.31432C14.8579 4.43146 14.7173 4.7048 14.7642 4.9547C14.7876 5.08746 14.824 5.15514 14.9776 5.34517C15.3342 5.78771 15.6024 6.37863 15.7429 7.03202C15.795 7.28453 15.7872 8.12535 15.7299 8.40649C15.4175 9.8955 14.3659 11.0018 12.9003 11.3767C12.4656 11.4886 12.3276 11.4938 9.66716 11.4938C8.26926 11.4964 7.11866 11.4886 7.11085 11.4756C7.10565 11.4652 7.36336 11.1919 7.68615 10.8717C8.00634 10.5489 8.28748 10.2521 8.31091 10.2105C8.36558 10.1038 8.3838 9.85906 8.34475 9.73671C8.23542 9.40871 7.83713 9.2369 7.52736 9.38789C7.45707 9.42173 7.02234 9.83823 6.25962 10.6036C5.21575 11.65 5.0934 11.7828 5.05435 11.8973C5.00229 12.0587 5.00229 12.116 5.05696 12.2852C5.096 12.4102 5.18451 12.5065 6.25962 13.5816C6.89739 14.2194 7.46228 14.7634 7.51174 14.7894C7.6445 14.8597 7.91002 14.8571 8.04539 14.7842C8.25885 14.6723 8.37339 14.4797 8.37339 14.2454C8.37339 14.0085 8.32913 13.946 7.70437 13.3187C7.38418 12.9959 7.12126 12.7225 7.12126 12.7147C7.12126 12.7043 8.34215 12.6913 9.83636 12.6861C12.7389 12.6783 12.6452 12.6809 13.1866 12.5455C14.4153 12.241 15.4644 11.5043 16.1647 10.4552C16.4744 9.99442 16.7972 9.2369 16.8805 8.78135C16.8961 8.69805 16.9144 8.61995 16.9196 8.60954C16.9274 8.59913 16.9508 8.38306 16.9742 8.12795C17.0185 7.63596 17.0055 7.29755 16.9196 6.81075C16.7868 6.04803 16.4614 5.31133 15.9798 4.67356C15.7325 4.34296 15.6414 4.28048 15.3915 4.26746C15.2353 4.25705 15.1859 4.26486 15.0922 4.31432Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  renameWorkflow: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2239_6001)">
        <path
          d="M9.96822 2.75228C10.4961 2.18039 10.76 1.89445 11.0404 1.72765C11.7171 1.3252 12.5504 1.31269 13.2384 1.69464C13.5235 1.85294 13.7955 2.13083 14.3396 2.68662C14.8837 3.24241 15.1557 3.5203 15.3106 3.81157C15.6845 4.51437 15.6723 5.36556 15.2783 6.05683C15.1151 6.34332 14.8351 6.61292 14.2753 7.15213L7.61438 13.5677C6.55347 14.5895 6.02302 15.1004 5.36006 15.3594C4.6971 15.6183 3.96828 15.5993 2.51065 15.5612L2.31232 15.556C1.86857 15.5444 1.6467 15.5386 1.51772 15.3922C1.38875 15.2458 1.40636 15.0198 1.44157 14.5678L1.46069 14.3223C1.55981 13.0501 1.60937 12.414 1.85781 11.8422C2.10624 11.2703 2.53478 10.806 3.39186 9.87744L9.96822 2.75228Z"
          stroke="#1D1D1D"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
        <path
          d="M9.20898 2.83325L14.1673 7.79159"
          stroke="#1D1D1D"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
        <path
          d="M9.91602 15.5834L15.5827 15.5834"
          stroke="#1D1D1D"
          stroke-width="1.0625"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2239_6001">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  updateDesign: (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.70789 0.0191507C1.28834 0.089694 0.835381 0.342164 0.538356 0.668891C0.178215 1.06245 0 1.51912 0 2.05377C0 2.63296 0.189353 3.0785 0.612612 3.50547C0.909637 3.80621 1.21409 3.97329 1.61507 4.05868C1.9418 4.12922 2.14229 4.12922 2.46901 4.05868C2.84401 3.98071 3.1596 3.80992 3.45662 3.52775C3.66454 3.33468 3.74993 3.21587 3.8873 2.93741L4.05809 2.59212H5.60262C6.44914 2.59212 7.12858 2.60697 7.11002 2.62183C7.08774 2.64039 6.92438 2.76291 6.73874 2.89286C6.07043 3.3681 5.28703 4.21462 4.84892 4.9349C4.31428 5.81855 3.92815 6.93981 3.83533 7.88287L3.80562 8.17618L3.56429 8.31355C2.82544 8.72939 2.50614 9.50165 2.74747 10.2888C2.94054 10.9125 3.54201 11.384 4.19918 11.4212C4.70412 11.4509 5.09397 11.3061 5.45782 10.9608C6.00731 10.4373 6.12984 9.64273 5.76598 8.97072C5.63975 8.74052 5.30559 8.42122 5.05684 8.29499C4.94917 8.24301 4.86377 8.1836 4.86377 8.16504C4.86377 8.01281 4.9603 7.47446 5.04941 7.13659C5.32787 6.07473 5.83281 5.19851 6.60879 4.40768C7.19541 3.81363 7.7709 3.41265 8.51346 3.08593C8.94785 2.89286 8.98498 2.88915 8.98498 3.03766C8.98498 3.2233 9.12607 3.53517 9.27087 3.67626C9.56047 3.95843 9.60131 3.96586 10.9156 3.96586C12.23 3.96586 12.2708 3.95843 12.5604 3.67626C12.7052 3.53517 12.8463 3.2233 12.8463 3.03766C12.8463 2.88915 12.8834 2.89286 13.3178 3.08593C14.8809 3.77651 16.1024 5.09455 16.6445 6.67621C16.8041 7.14773 16.9675 7.89772 16.9675 8.16133C16.9675 8.17989 16.8673 8.24672 16.7447 8.31355C16.4997 8.4435 16.1581 8.78508 16.0393 9.01527C15.798 9.48308 15.8017 10.0734 16.043 10.5449C16.147 10.7454 16.4626 11.0759 16.6631 11.1947C17.7732 11.8481 19.1581 11.061 19.1581 9.7764C19.1581 9.14522 18.8239 8.60315 18.2558 8.30241L18.0257 8.17989L17.996 7.88287C17.9588 7.50416 17.8103 6.83586 17.6655 6.40146C17.5356 6.00419 17.1754 5.23935 16.9601 4.89406C16.4366 4.06239 15.6532 3.26043 14.777 2.65895C14.6878 2.59955 14.7658 2.59584 16.2287 2.59584L17.7732 2.59212L17.944 2.93741C18.5826 4.22576 20.2162 4.50793 21.2187 3.50176C21.6419 3.0785 21.8313 2.63296 21.8313 2.05377C21.8313 1.8904 21.8053 1.6565 21.7756 1.53397C21.6048 0.884233 21.0776 0.319887 20.4278 0.0971193C20.1308 -0.00312614 19.5479 -0.0216904 19.2509 0.0637035C18.6457 0.234493 18.1073 0.709732 17.8809 1.27408L17.7917 1.49685L15.319 1.50798L12.8463 1.51541V1.23695C12.8463 0.865669 12.7461 0.605773 12.5307 0.405282C12.2448 0.145386 12.2337 0.141673 10.9416 0.141673C10.1694 0.141673 9.74239 0.156524 9.64586 0.186227C9.46022 0.241919 9.18919 0.479538 9.08894 0.676316C9.02954 0.787701 9.00355 0.917648 8.99241 1.17383L8.97756 1.51541L6.50854 1.50798L4.03953 1.49685L3.95042 1.27408C3.7128 0.680029 3.11504 0.178801 2.49129 0.0451403C2.25738 -0.00312614 1.91209 -0.0142651 1.70789 0.0191507ZM2.44302 1.13299C2.78831 1.27779 3.0445 1.67135 3.0445 2.05377C3.04079 2.97454 1.86383 3.3978 1.2772 2.68123C0.969041 2.30624 0.969041 1.77531 1.28463 1.41145C1.57052 1.0773 2.03833 0.962202 2.44302 1.13299ZM20.2088 1.15156C20.5318 1.28893 20.7917 1.68991 20.7917 2.05377C20.7917 2.59212 20.3387 3.03766 19.793 3.03766C18.7571 3.03395 18.4081 1.72704 19.2954 1.17754C19.5442 1.02161 19.8783 1.01418 20.2088 1.15156ZM11.7881 2.05377V2.90771H10.9156H10.0431L10.032 2.09089C10.0283 1.64165 10.032 1.25551 10.0431 1.22952C10.0543 1.18868 10.2436 1.18126 10.9231 1.18868L11.7881 1.19982V2.05377ZM4.51848 9.21948C4.77838 9.33086 4.90833 9.51279 4.90833 9.7764C4.90833 10.2219 4.46279 10.5078 4.06923 10.3148C3.57172 10.0734 3.62741 9.36056 4.15463 9.20091C4.30314 9.15636 4.36997 9.16007 4.51848 9.21948ZM17.814 9.26774C17.97 9.34942 18.1185 9.59818 18.1185 9.7764C18.1185 9.96946 17.97 10.2071 17.7806 10.3073C17.3908 10.5152 16.923 10.2256 16.923 9.7764C16.923 9.5165 17.0492 9.33457 17.3017 9.21948C17.4539 9.15264 17.6247 9.1675 17.814 9.26774Z"
        fill="#1D1D1D"
      />
      <path
        d="M10.6662 5.6441C10.618 5.66638 10.3172 6.00425 9.99422 6.39409C9.6712 6.78393 8.62419 8.04629 7.66629 9.20097C6.70839 10.3556 5.86187 11.3878 5.7839 11.4992C5.40148 12.045 5.25297 12.9138 5.42376 13.6081C5.44975 13.7046 5.69851 14.3358 5.97697 15.0115L6.48562 16.2367L6.38909 16.3073C6.17374 16.4669 5.91013 16.7714 5.81731 16.9682C5.67252 17.2689 5.61682 17.6402 5.67252 17.9261C5.79875 18.6166 6.29998 19.1327 6.96086 19.2627C7.12051 19.2924 8.25291 19.2998 11.0635 19.2924L14.9434 19.2812L15.2218 19.1476C15.7305 18.9062 16.0535 18.483 16.1575 17.9261C16.2132 17.6402 16.1575 17.2689 16.0127 16.9682C15.9236 16.7751 15.6117 16.4187 15.4223 16.2887C15.3444 16.2367 15.3481 16.2293 15.7862 15.1786C16.3468 13.8308 16.4396 13.5635 16.4693 13.17C16.5102 12.6353 16.3728 12.0375 16.1166 11.6106C16.0424 11.4881 15.4409 10.7381 14.7763 9.9361C14.1117 9.13785 13.0647 7.87179 12.4447 7.12551C11.8246 6.37924 11.2677 5.7295 11.2009 5.68123C11.0746 5.59212 10.8147 5.57356 10.6662 5.6441ZM10.3952 9.40146V11.165L10.1836 11.2616C9.36304 11.6366 8.93236 12.5239 9.15141 13.3779C9.24052 13.712 9.41502 14.0053 9.67492 14.2467C10.4323 14.9558 11.5276 14.9224 12.2442 14.1613C13.0944 13.2628 12.8011 11.8074 11.6687 11.2727L11.4348 11.1613V9.40146C11.4348 8.41757 11.4496 7.64159 11.4682 7.64159C11.4868 7.64159 12.3259 8.63662 13.332 9.85071C15.2701 12.1861 15.3444 12.2863 15.4075 12.7281C15.4669 13.1365 15.4112 13.3296 14.8506 14.6811C14.5647 15.3716 14.3159 15.9657 14.3011 15.9954C14.2714 16.0437 13.8481 16.0511 10.9261 16.0622C8.2789 16.0697 7.57718 16.0585 7.54748 16.0251C7.51407 15.9805 6.9163 14.5511 6.60072 13.7566C6.51903 13.5524 6.43735 13.2925 6.41879 13.17C6.35196 12.7541 6.49304 12.2715 6.78636 11.9187C7.41011 11.1613 9.9014 8.15767 10.0908 7.92748C10.2244 7.77154 10.3469 7.64159 10.3655 7.64159C10.3803 7.64159 10.3952 8.43242 10.3952 9.40146ZM11.2232 12.2232C11.3642 12.2826 11.5276 12.4422 11.613 12.5982C11.691 12.743 11.691 13.118 11.613 13.2665C11.2751 13.9051 10.3284 13.7937 10.1724 13.092C10.0945 12.7467 10.269 12.3903 10.592 12.2306C10.7368 12.1601 11.0635 12.1526 11.2232 12.2232ZM14.8134 17.1761C15.2033 17.3691 15.2144 17.9409 14.832 18.1748C14.7243 18.2379 14.5498 18.2416 10.915 18.2416C7.28759 18.2416 7.10566 18.2379 6.99799 18.1748C6.60072 17.9298 6.61557 17.3728 7.02398 17.1724C7.13536 17.1167 7.51407 17.1092 10.915 17.1092C14.431 17.1092 14.6909 17.113 14.8134 17.1761Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  deleteWorkflow: (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 10.5V14.875"
        stroke="#1D1D1D"
        stroke-width="1.16667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.25 10.5V14.875"
        stroke="#1D1D1D"
        stroke-width="1.16667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 6.12512H17.5"
        stroke="#1D1D1D"
        stroke-width="1.16667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 8.75012V15.7501C5.25 17.1999 6.42526 18.3751 7.875 18.3751H13.125C14.5748 18.3751 15.75 17.1999 15.75 15.7501V8.75012"
        stroke="#1D1D1D"
        stroke-width="1.16667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.875 4.375C7.875 3.4085 8.6585 2.625 9.625 2.625H11.375C12.3415 2.625 13.125 3.4085 13.125 4.375V6.125H7.875V4.375Z"
        stroke="#1D1D1D"
        stroke-width="1.16667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  deleteIconWorkflow: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4453 30V43.8889"
        stroke="#EA464A"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35.5547 30V43.8889"
        stroke="#EA464A"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.77734 16.1117H52.2218"
        stroke="#EA464A"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.334 24.4449V46.6672C13.334 51.2697 17.065 55.0005 21.6673 55.0005H38.334C42.9365 55.0005 46.6673 51.2697 46.6673 46.6672V24.4449"
        stroke="#EA464A"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.666 10.5556C21.666 7.48731 24.1533 5 27.2216 5H32.7771C35.8455 5 38.3327 7.48731 38.3327 10.5556V16.1111H21.666V10.5556Z"
        stroke="#EA464A"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  autoPushIconWorkflow: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.08105 8.04126C8.2823 8.03865 8.33496 8.02839 8.44727 7.97095C8.61464 7.88464 8.77178 7.72423 8.85547 7.5647L8.91797 7.4397L8.92578 4.552L8.93066 1.66528L8.85547 1.50317C8.76657 1.31231 8.61755 1.15492 8.44238 1.0686C8.34571 1.02157 8.26439 1.00647 8.09473 1.00122C7.9725 0.99862 7.85489 1.00067 7.83301 1.01099C7.56625 1.1156 7.41718 1.24182 7.29688 1.46411L7.21777 1.60767L7.20996 4.4895L7.20508 7.37427L7.27832 7.53638C7.36724 7.73252 7.506 7.87418 7.70215 7.97095C7.82743 8.03096 7.87734 8.04126 8.08105 8.04126ZM8.05566 16.2922C9.48344 16.2922 10.7989 15.9002 11.96 15.134C12.9799 14.4567 13.7778 13.5723 14.3584 12.4661C14.5415 12.1156 14.7955 11.4746 14.8818 11.1399C14.8897 11.1033 14.9098 11.0331 14.9229 10.9836C15.0902 10.3508 15.177 9.47647 15.1299 8.8645C15.088 8.31035 14.9883 7.67282 14.8916 7.36157C14.5045 6.09579 13.9922 5.19799 13.1553 4.31665C12.7996 3.94272 12.1614 3.4309 11.8711 3.28442C11.6803 3.19032 11.3772 3.18715 11.1758 3.27856C10.6658 3.51394 10.5138 4.14972 10.8643 4.59692C10.9009 4.644 11.0398 4.75899 11.168 4.8479C12.3369 5.66909 13.1034 6.90094 13.3701 8.3811C13.4067 8.58769 13.4141 8.7739 13.4141 9.27075C13.4114 9.84287 13.4061 9.9267 13.3408 10.2375C13.3016 10.4232 13.2601 10.612 13.2471 10.6565C13.1294 11.02 13.0817 11.1532 13.0137 11.3206C12.6449 12.207 11.9026 13.1197 11.1182 13.6506C10.1899 14.2756 9.15688 14.592 8.04297 14.592C6.65427 14.592 5.33321 14.0429 4.28711 13.0334C3.74315 12.5078 3.25395 11.726 3.01074 10.9963C2.87476 10.5858 2.87167 10.578 2.81152 10.2903C2.65725 9.52933 2.68962 8.507 2.89355 7.83228C2.92228 7.73044 2.95563 7.61258 2.96875 7.57056C3.04457 7.28559 3.34513 6.65798 3.55957 6.32837C3.93872 5.74787 4.33903 5.32119 4.86719 4.92896C5.26191 4.63618 5.36398 4.51057 5.42676 4.24146C5.46599 4.07408 5.44533 3.90335 5.36426 3.7229C5.28589 3.55324 5.21242 3.46998 5.04785 3.36548C4.82032 3.21641 4.5824 3.18218 4.3418 3.26587C4.17714 3.32077 4.08027 3.38119 3.78223 3.60864C3.17301 4.07409 2.66333 4.618 2.20312 5.28735C2.10771 5.4266 2.0295 5.54795 2.02734 5.55884C2.02734 5.56668 2.00631 5.60621 1.97754 5.64282C1.91479 5.73173 1.63822 6.28588 1.54395 6.51099C1.48118 6.66006 1.31311 7.13666 1.24512 7.36157C1.23193 7.40402 1.19564 7.55234 1.16699 7.68774C1.01534 8.40415 0.968263 9.07122 1.02051 9.71704C1.08066 10.4336 1.15378 10.816 1.35254 11.428C1.5042 11.8986 1.63785 12.1992 1.93066 12.7483C2.01958 12.9131 2.36 13.4102 2.51953 13.6116C3.17593 14.4327 3.96811 15.0764 4.9043 15.5471C5.14739 15.67 5.25218 15.7193 5.44043 15.7952C5.6549 15.8841 6.23299 16.073 6.4082 16.1096C7.11148 16.256 7.43594 16.2922 8.05566 16.2922Z"
        fill="black"
      />
      <path
        d="M8.08105 8.04126L8.08365 8.24126L8.08105 8.24126L8.08105 8.04126ZM8.44727 7.97095L8.53892 8.14871L8.53833 8.14901L8.44727 7.97095ZM8.85547 7.5647L9.03439 7.65416L9.03258 7.65761L8.85547 7.5647ZM8.91797 7.4397L9.11797 7.44024L9.11784 7.48717L9.09685 7.52914L8.91797 7.4397ZM8.92578 4.552L9.12578 4.55234L9.12578 4.55254L8.92578 4.552ZM8.93066 1.66528L9.1121 1.58113L9.13074 1.62132L9.13066 1.66562L8.93066 1.66528ZM8.85547 1.50317L9.03677 1.41873L9.0369 1.41902L8.85547 1.50317ZM8.44238 1.0686L8.52988 0.888754L8.53078 0.889202L8.44238 1.0686ZM8.09473 1.00122L8.09898 0.801257L8.10091 0.801316L8.09473 1.00122ZM7.83301 1.01099L7.91849 1.19229L7.90603 1.19718L7.83301 1.01099ZM7.29688 1.46411L7.47277 1.5593L7.47204 1.56063L7.29688 1.46411ZM7.21777 1.60767L7.01777 1.60712L7.01791 1.55596L7.04261 1.51115L7.21777 1.60767ZM7.20996 4.4895L7.00996 4.48916L7.00996 4.48896L7.20996 4.4895ZM7.20508 7.37427L7.02282 7.45661L7.00501 7.41719L7.00508 7.37393L7.20508 7.37427ZM7.27832 7.53638L7.09616 7.61895L7.09606 7.61872L7.27832 7.53638ZM7.70215 7.97095L7.61574 8.15133L7.61366 8.15031L7.70215 7.97095ZM8.05566 16.2922L8.05567 16.4922H8.05566V16.2922ZM11.96 15.134L12.0706 15.3006L12.0701 15.301L11.96 15.134ZM14.3584 12.4661L14.5357 12.5587L14.5355 12.559L14.3584 12.4661ZM14.8818 11.1399L15.0775 11.182L15.0755 11.1898L14.8818 11.1399ZM14.9229 10.9836L14.7294 10.9327L14.7295 10.9325L14.9229 10.9836ZM15.1299 8.8645L14.9305 8.87984L14.9305 8.87956L15.1299 8.8645ZM14.8916 7.36157L14.7006 7.42092L14.7003 7.42006L14.8916 7.36157ZM13.1553 4.31665L13.3002 4.17881L13.3003 4.17893L13.1553 4.31665ZM11.8711 3.28442L11.9596 3.10504L11.9612 3.10587L11.8711 3.28442ZM11.1758 3.27856L11.092 3.09697L11.0931 3.09645L11.1758 3.27856ZM10.8643 4.59692L11.0217 4.47356L11.0221 4.47413L10.8643 4.59692ZM11.168 4.8479L11.282 4.68358L11.2829 4.68425L11.168 4.8479ZM13.3701 8.3811L13.5669 8.34563L13.567 8.34621L13.3701 8.3811ZM13.4141 9.27075L13.6141 9.27075L13.6141 9.27167L13.4141 9.27075ZM13.3408 10.2375L13.5365 10.2787L13.5365 10.2789L13.3408 10.2375ZM13.2471 10.6565L13.439 10.7129L13.4373 10.7181L13.2471 10.6565ZM13.0137 11.3206L13.199 11.3958L13.1983 11.3974L13.0137 11.3206ZM11.1182 13.6506L11.2303 13.8163L11.2299 13.8165L11.1182 13.6506ZM8.04297 14.592L8.04298 14.792H8.04297V14.592ZM4.28711 13.0334L4.14823 13.1774L4.14813 13.1773L4.28711 13.0334ZM3.01074 10.9963L2.82101 11.0596L2.82088 11.0592L3.01074 10.9963ZM2.81152 10.2903L2.61575 10.3312L2.61551 10.33L2.81152 10.2903ZM2.89355 7.83228L3.08608 7.88658L3.085 7.89014L2.89355 7.83228ZM2.96875 7.57056L3.1622 7.62203L3.15966 7.63017L2.96875 7.57056ZM3.55957 6.32837L3.39193 6.2193L3.39212 6.219L3.55957 6.32837ZM4.86719 4.92896L4.74794 4.76839L4.74804 4.76832L4.86719 4.92896ZM5.42676 4.24146L5.23199 4.19602L5.23203 4.19582L5.42676 4.24146ZM5.36426 3.7229L5.54583 3.63903L5.54669 3.64094L5.36426 3.7229ZM5.04785 3.36548L4.94063 3.53433L4.93825 3.53277L5.04785 3.36548ZM4.3418 3.26587L4.40751 3.45478L4.40506 3.4556L4.3418 3.26587ZM3.78223 3.60864L3.66081 3.44972L3.66089 3.44965L3.78223 3.60864ZM2.20312 5.28735L2.03814 5.17431L2.03832 5.17404L2.20312 5.28735ZM2.02734 5.55884H1.82734V5.53926L1.83114 5.52006L2.02734 5.55884ZM1.97754 5.64282L1.81392 5.52734L1.82028 5.51926L1.97754 5.64282ZM1.54395 6.51099L1.72842 6.58824L1.72827 6.5886L1.54395 6.51099ZM1.24512 7.36157L1.43657 7.41945L1.43611 7.42093L1.24512 7.36157ZM1.16699 7.68774L1.36266 7.72915L1.36266 7.72916L1.16699 7.68774ZM1.02051 9.71704L0.821208 9.73377L0.821159 9.73317L1.02051 9.71704ZM1.35254 11.428L1.54276 11.3662L1.5429 11.3666L1.35254 11.428ZM1.93066 12.7483L1.75466 12.8433L1.75419 12.8424L1.93066 12.7483ZM2.51953 13.6116L2.36331 13.7365L2.36276 13.7358L2.51953 13.6116ZM4.9043 15.5471L4.99414 15.3684L4.99451 15.3686L4.9043 15.5471ZM5.44043 15.7952L5.51516 15.6096L5.51703 15.6104L5.44043 15.7952ZM6.4082 16.1096L6.36744 16.3054L6.3673 16.3054L6.4082 16.1096ZM8.08105 8.04126L8.07846 7.84128C8.1796 7.83996 8.22682 7.8366 8.25973 7.83026C8.28603 7.8252 8.30831 7.81738 8.3562 7.79288L8.44727 7.97095L8.53833 8.14901C8.47392 8.18196 8.41371 8.20798 8.33529 8.22306C8.26349 8.23687 8.18375 8.23994 8.08365 8.24124L8.08105 8.04126ZM8.44727 7.97095L8.35561 7.79319C8.4853 7.72631 8.61315 7.5961 8.67836 7.47179L8.85547 7.5647L9.03258 7.65761C8.93041 7.85236 8.74398 8.04297 8.53892 8.14871L8.44727 7.97095ZM8.85547 7.5647L8.67658 7.47525L8.73908 7.35025L8.91797 7.4397L9.09685 7.52914L9.03435 7.65414L8.85547 7.5647ZM8.91797 7.4397L8.71797 7.43916L8.72578 4.55146L8.92578 4.552L9.12578 4.55254L9.11797 7.44024L8.91797 7.4397ZM8.92578 4.552L8.72578 4.55166L8.73066 1.66494L8.93066 1.66528L9.13066 1.66562L9.12578 4.55234L8.92578 4.552ZM8.93066 1.66528L8.74923 1.74944L8.67404 1.58733L8.85547 1.50317L9.0369 1.41902L9.1121 1.58113L8.93066 1.66528ZM8.85547 1.50317L8.67417 1.58761C8.6027 1.43417 8.48457 1.31236 8.35398 1.24801L8.44238 1.0686L8.53078 0.889202C8.75053 0.997482 8.93044 1.19044 9.03677 1.41873L8.85547 1.50317ZM8.44238 1.0686L8.35489 1.24845C8.29477 1.2192 8.24584 1.20599 8.08855 1.20113L8.09473 1.00122L8.10091 0.801316C8.28295 0.806944 8.39664 0.823941 8.52988 0.888756L8.44238 1.0686ZM8.09473 1.00122L8.09047 1.20118C8.03127 1.19992 7.9751 1.19983 7.93246 1.20116C7.91084 1.20184 7.89538 1.2028 7.88586 1.20375C7.88099 1.20424 7.88024 1.20447 7.88231 1.20409C7.88342 1.20388 7.88681 1.20322 7.8917 1.20186C7.8959 1.2007 7.90584 1.19776 7.9183 1.19189L7.83301 1.01099L7.74772 0.830084C7.77443 0.817491 7.79933 0.812671 7.80874 0.81091C7.8219 0.808447 7.83488 0.806852 7.84603 0.805737C7.86853 0.803485 7.89421 0.802161 7.92001 0.801357C7.9722 0.799731 8.03595 0.799925 8.09898 0.801266L8.09473 1.00122ZM7.83301 1.01099L7.90603 1.19718C7.67714 1.28694 7.56767 1.38395 7.47277 1.5593L7.29688 1.46411L7.12098 1.36892C7.26669 1.09968 7.45537 0.944252 7.75999 0.824792L7.83301 1.01099ZM7.29688 1.46411L7.47204 1.56063L7.39294 1.70419L7.21777 1.60767L7.04261 1.51115L7.12171 1.36759L7.29688 1.46411ZM7.21777 1.60767L7.41777 1.60821L7.40996 4.49004L7.20996 4.4895L7.00996 4.48896L7.01777 1.60712L7.21777 1.60767ZM7.20996 4.4895L7.40996 4.48984L7.40508 7.37461L7.20508 7.37427L7.00508 7.37393L7.00996 4.48916L7.20996 4.4895ZM7.20508 7.37427L7.38734 7.29192L7.46058 7.45403L7.27832 7.53638L7.09606 7.61872L7.02282 7.45661L7.20508 7.37427ZM7.27832 7.53638L7.46048 7.4538C7.52979 7.6067 7.63485 7.71473 7.79063 7.79159L7.70215 7.97095L7.61366 8.15031C7.37716 8.03363 7.20468 7.85834 7.09616 7.61895L7.27832 7.53638ZM7.70215 7.97095L7.78855 7.79057C7.84582 7.818 7.87111 7.82678 7.89914 7.83205C7.93244 7.83831 7.97896 7.84126 8.08106 7.84126L8.08105 8.04126L8.08105 8.24126C7.97943 8.24126 7.89914 8.23905 7.82524 8.22516C7.74606 8.21028 7.68376 8.1839 7.61575 8.15132L7.70215 7.97095ZM8.05566 16.2922L8.05566 16.0922C9.44509 16.0922 10.7221 15.7112 11.8498 14.9671L11.96 15.134L12.0701 15.301C10.8757 16.0891 9.52178 16.4922 8.05567 16.4922L8.05566 16.2922ZM11.96 15.134L11.8493 14.9674C12.841 14.3089 13.6162 13.4499 14.1813 12.3731L14.3584 12.4661L14.5355 12.559C13.9395 13.6947 13.1188 14.6045 12.0706 15.3006L11.96 15.134ZM14.3584 12.4661L14.1811 12.3735C14.3583 12.0342 14.6063 11.4075 14.6882 11.09L14.8818 11.1399L15.0755 11.1898C14.9848 11.5417 14.7246 12.197 14.5357 12.5587L14.3584 12.4661ZM14.8818 11.1399L14.6863 11.0978C14.6954 11.0555 14.7188 10.973 14.7294 10.9327L14.9229 10.9836L15.1163 11.0346C15.1008 11.0933 15.084 11.1511 15.0774 11.182L14.8818 11.1399ZM14.9229 10.9836L14.7295 10.9325C14.8916 10.3194 14.9757 9.46764 14.9305 8.87984L15.1299 8.8645L15.3293 8.84916C15.3782 9.4853 15.2888 10.3821 15.1162 11.0348L14.9229 10.9836ZM15.1299 8.8645L14.9305 8.87956C14.889 8.33078 14.7907 7.71078 14.7006 7.42092L14.8916 7.36157L15.0826 7.30223C15.1859 7.63486 15.2871 8.28992 15.3293 8.84944L15.1299 8.8645ZM14.8916 7.36157L14.7003 7.42006C14.3215 6.18129 13.824 5.31132 13.0102 4.45437L13.1553 4.31665L13.3003 4.17893C14.1603 5.08465 14.6875 6.0103 15.0829 7.30309L14.8916 7.36157ZM13.1553 4.31665L13.0104 4.45449C12.8406 4.27597 12.5993 4.06062 12.3634 3.87117C12.1243 3.67911 11.906 3.52607 11.781 3.46298L11.8711 3.28442L11.9612 3.10587C12.1264 3.18925 12.3724 3.36537 12.6139 3.55931C12.8586 3.75588 13.1143 3.9834 13.3002 4.17881L13.1553 4.31665ZM11.8711 3.28442L11.7826 3.4638C11.7209 3.43335 11.6288 3.41285 11.5256 3.41191C11.4227 3.41099 11.3268 3.42967 11.2585 3.46068L11.1758 3.27856L11.0931 3.09645C11.2262 3.03605 11.3825 3.01061 11.5292 3.01193C11.6756 3.01325 11.8305 3.04139 11.9596 3.10505L11.8711 3.28442ZM11.1758 3.27856L11.2596 3.46016C10.8684 3.64073 10.7498 4.1266 11.0217 4.47356L10.8643 4.59692L10.7068 4.72028C10.2778 4.17283 10.4633 3.38714 11.092 3.09697L11.1758 3.27856ZM10.8643 4.59692L11.0221 4.47413C11.0211 4.47276 11.0269 4.47989 11.0454 4.49713C11.062 4.51252 11.0836 4.53143 11.1092 4.55258C11.1604 4.59491 11.2227 4.64247 11.282 4.68358L11.168 4.8479L11.054 5.01222C10.9851 4.96442 10.9138 4.91003 10.8544 4.86087C10.8006 4.81643 10.7401 4.76302 10.7064 4.71972L10.8643 4.59692ZM11.168 4.8479L11.2829 4.68425C12.4976 5.53754 13.2914 6.81685 13.5669 8.34563L13.3701 8.3811L13.1733 8.41657C12.9153 6.98504 12.1762 5.80063 11.053 5.01155L11.168 4.8479ZM13.3701 8.3811L13.567 8.34621C13.6071 8.57246 13.6141 8.77536 13.6141 9.27075H13.4141H13.2141C13.2141 8.77244 13.2063 8.60291 13.1732 8.416L13.3701 8.3811ZM13.4141 9.27075L13.6141 9.27167C13.6114 9.84766 13.6061 9.94767 13.5365 10.2787L13.3408 10.2375L13.1451 10.1964C13.2062 9.90572 13.2115 9.83808 13.2141 9.26984L13.4141 9.27075ZM13.3408 10.2375L13.5365 10.2789C13.4983 10.4596 13.4548 10.6589 13.4389 10.7129L13.2471 10.6565L13.0552 10.6001C13.0655 10.5652 13.1049 10.3869 13.1451 10.1962L13.3408 10.2375ZM13.2471 10.6565L13.4373 10.7181C13.3192 11.0832 13.2697 11.2217 13.199 11.3958L13.0137 11.3206L12.8284 11.2453C12.8936 11.0846 12.9396 10.9568 13.0568 10.5949L13.2471 10.6565ZM13.0137 11.3206L13.1983 11.3974C12.8148 12.3194 12.0476 13.2631 11.2303 13.8163L11.1182 13.6506L11.0061 13.485C11.7577 12.9763 12.475 12.0947 12.829 11.2437L13.0137 11.3206ZM11.1182 13.6506L11.2299 13.8165C10.2688 14.4636 9.19691 14.7919 8.04298 14.792L8.04297 14.592L8.04295 14.392C9.11686 14.392 10.111 14.0876 11.0065 13.4847L11.1182 13.6506ZM8.04297 14.592V14.792C6.5997 14.792 5.22958 14.2209 4.14823 13.1774L4.28711 13.0334L4.42599 12.8895C5.43684 13.865 6.70884 14.392 8.04297 14.392V14.592ZM4.28711 13.0334L4.14813 13.1773C3.58051 12.6287 3.07418 11.8191 2.82101 11.0596L3.01074 10.9963L3.20048 10.9331C3.43373 11.6329 3.9058 12.3868 4.42609 12.8896L4.28711 13.0334ZM3.01074 10.9963L2.82088 11.0592C2.68375 10.6452 2.6781 10.6294 2.61576 10.3312L2.81152 10.2903L3.00729 10.2494C3.06525 10.5266 3.06576 10.5264 3.2006 10.9335L3.01074 10.9963ZM2.81152 10.2903L2.61551 10.33C2.45545 9.5405 2.48754 8.48434 2.70211 7.77441L2.89355 7.83228L3.085 7.89014C2.89171 8.52965 2.85906 9.51815 3.00754 10.2505L2.81152 10.2903ZM2.89355 7.83228L2.70106 7.77798C2.72927 7.67798 2.76365 7.55637 2.77784 7.51094L2.96875 7.57056L3.15966 7.63017C3.1476 7.66878 3.11528 7.78291 3.08604 7.88657L2.89355 7.83228ZM2.96875 7.57056L2.77547 7.51913C2.81841 7.35776 2.91935 7.11568 3.03164 6.88014C3.14514 6.64206 3.27814 6.3942 3.39193 6.2193L3.55957 6.32837L3.72722 6.43743C3.62656 6.59215 3.50206 6.8229 3.39271 7.05227C3.28216 7.28418 3.19491 7.49839 3.16203 7.62198L2.96875 7.57056ZM3.55957 6.32837L3.39212 6.219C3.7837 5.61949 4.2001 5.17525 4.74794 4.76839L4.86719 4.92896L4.98643 5.08952C4.47795 5.46714 4.09375 5.87626 3.72702 6.43774L3.55957 6.32837ZM4.86719 4.92896L4.74804 4.76832C4.94487 4.62232 5.05089 4.53051 5.11632 4.4501C5.17492 4.37809 5.20548 4.30966 5.23199 4.19602L5.42676 4.24146L5.62153 4.28689C5.58526 4.44236 5.5334 4.5713 5.42658 4.70257C5.3266 4.82543 5.18422 4.94282 4.98633 5.08959L4.86719 4.92896ZM5.42676 4.24146L5.23203 4.19582C5.25976 4.07753 5.24778 3.95168 5.18182 3.80486L5.36426 3.7229L5.54669 3.64094C5.64288 3.85503 5.67221 4.07063 5.62148 4.28709L5.42676 4.24146ZM5.36426 3.7229L5.18269 3.80677C5.14833 3.73237 5.12003 3.68781 5.08859 3.65227C5.05685 3.6164 5.01423 3.58105 4.94064 3.53432L5.04785 3.36548L5.15506 3.19664C5.24604 3.25441 5.32245 3.31294 5.38817 3.38723C5.4542 3.46187 5.50182 3.54376 5.54582 3.63903L5.36426 3.7229ZM5.04785 3.36548L4.93825 3.53277C4.75803 3.4147 4.58446 3.39322 4.4075 3.45477L4.3418 3.26587L4.27609 3.07697C4.58034 2.97115 4.88262 3.01812 5.15746 3.19819L5.04785 3.36548ZM4.3418 3.26587L4.40506 3.4556C4.27456 3.49911 4.20044 3.54107 3.90356 3.76763L3.78223 3.60864L3.66089 3.44965C3.96009 3.22132 4.07971 3.14243 4.27853 3.07614L4.3418 3.26587ZM3.78223 3.60864L3.90365 3.76757C3.31247 4.21923 2.81711 4.74735 2.36793 5.40066L2.20312 5.28735L2.03832 5.17404C2.50955 4.48865 3.03355 3.92894 3.66081 3.44972L3.78223 3.60864ZM2.20312 5.28735L2.36811 5.4004C2.3212 5.46887 2.27881 5.53251 2.24821 5.57982C2.2328 5.60365 2.22106 5.62231 2.21342 5.63494C2.20946 5.64147 2.20759 5.64478 2.20711 5.64566C2.20679 5.64625 2.20793 5.64421 2.20965 5.64055C2.21051 5.63872 2.21228 5.63486 2.21429 5.62966C2.21572 5.62598 2.22032 5.61397 2.22355 5.59762L2.02734 5.55884L1.83114 5.52006C1.83657 5.49261 1.84716 5.47143 1.8476 5.4705C1.85075 5.46379 1.85388 5.4579 1.85609 5.45386C1.86068 5.44547 1.86601 5.43642 1.87119 5.42787C1.8818 5.41033 1.89597 5.38791 1.91231 5.36263C1.94522 5.31174 1.98964 5.24509 2.03814 5.17431L2.20312 5.28735ZM2.02734 5.55884H2.22734C2.22734 5.59393 2.21786 5.62121 2.21621 5.62618C2.21269 5.63679 2.20884 5.64586 2.20599 5.6522C2.20011 5.66527 2.19328 5.6781 2.18672 5.68955C2.17343 5.71272 2.15563 5.73988 2.1348 5.76639L1.97754 5.64282L1.82028 5.51926C1.82822 5.50915 1.83532 5.49824 1.83974 5.49053C1.84203 5.48654 1.84226 5.48574 1.84123 5.48804C1.84079 5.489 1.83882 5.49341 1.83656 5.50022C1.83541 5.50367 1.83354 5.50969 1.83181 5.51754C1.83092 5.52157 1.82988 5.52692 1.82903 5.53331C1.8282 5.53953 1.82734 5.54829 1.82734 5.55884H2.02734ZM1.97754 5.64282L2.14094 5.75815C2.14095 5.75814 2.14034 5.759 2.13903 5.76103C2.13776 5.76299 2.13611 5.76562 2.13404 5.769C2.12988 5.77581 2.12469 5.78463 2.11847 5.79554C2.10601 5.81737 2.09067 5.84536 2.07307 5.87839C2.03793 5.94433 1.99537 6.02731 1.9515 6.11517C1.86308 6.29225 1.77286 6.48214 1.72842 6.58824L1.54395 6.51099L1.35947 6.43373C1.40931 6.31473 1.5045 6.11499 1.59363 5.93649C1.63853 5.84656 1.68277 5.76026 1.72008 5.69026C1.75486 5.62499 1.78986 5.56189 1.81414 5.52749L1.97754 5.64282ZM1.54395 6.51099L1.72827 6.5886C1.66897 6.72944 1.50318 7.1991 1.43656 7.41945L1.24512 7.36157L1.05367 7.30369C1.12305 7.07422 1.29339 6.59067 1.35962 6.43337L1.54395 6.51099ZM1.24512 7.36157L1.43611 7.42093C1.42592 7.45372 1.39124 7.59407 1.36266 7.72915L1.16699 7.68774L0.971324 7.64634C1.00004 7.51061 1.03794 7.35432 1.05413 7.30222L1.24512 7.36157ZM1.16699 7.68774L1.36266 7.72916C1.21457 8.42876 1.16933 9.07637 1.21986 9.70091L1.02051 9.71704L0.821159 9.73317C0.767193 9.06607 0.816121 8.37955 0.971328 7.64633L1.16699 7.68774ZM1.02051 9.71704L1.21981 9.70031C1.27885 10.4037 1.34936 10.7708 1.54276 11.3662L1.35254 11.428L1.16232 11.4898C0.958196 10.8613 0.882466 10.4635 0.821209 9.73377L1.02051 9.71704ZM1.35254 11.428L1.5429 11.3666C1.68993 11.8229 1.81817 12.1123 2.10714 12.6542L1.93066 12.7483L1.75419 12.8424C1.45753 12.2861 1.31847 11.9743 1.16218 11.4893L1.35254 11.428ZM1.93066 12.7483L2.10667 12.6533C2.1881 12.8042 2.52095 13.2913 2.6763 13.4874L2.51953 13.6116L2.36276 13.7358C2.19905 13.5291 1.85106 13.0219 1.75466 12.8433L1.93066 12.7483ZM2.51953 13.6116L2.67575 13.4867C3.31429 14.2854 4.08389 14.9108 4.99414 15.3684L4.9043 15.5471L4.81446 15.7258C3.85233 15.2421 3.03757 14.5799 2.36331 13.7365L2.51953 13.6116ZM4.9043 15.5471L4.99451 15.3686C5.23493 15.4901 5.33416 15.5368 5.51515 15.6096L5.44043 15.7952L5.36571 15.9807C5.17019 15.9019 5.05986 15.8498 4.81409 15.7256L4.9043 15.5471ZM5.44043 15.7952L5.51703 15.6104C5.72407 15.6963 6.28979 15.8806 6.44911 15.9138L6.4082 16.1096L6.3673 16.3054C6.17619 16.2655 5.58574 16.0719 5.36383 15.9799L5.44043 15.7952ZM6.4082 16.1096L6.44896 15.9138C7.14099 16.0579 7.45168 16.0922 8.05566 16.0922V16.2922V16.4922C7.42021 16.4922 7.08198 16.4542 6.36744 16.3054L6.4082 16.1096Z"
        fill="white"
      />
    </svg>
  ),
  autoVerificationIconWorkflow: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.61259 2.08337C5.39069 2.134 4.0929 2.34551 3.20619 3.22914C2.43012 4.00252 2.1707 5.08968 2.08398 6.83337M12.3887 2.08337C14.6106 2.134 15.9084 2.34551 16.7951 3.22914C17.5712 4.00252 17.8306 5.08968 17.9173 6.83337M12.3887 17.9167C14.6106 17.8661 15.9084 17.6546 16.7951 16.7709C17.5712 15.9976 17.8306 14.9104 17.9173 13.1667M7.61259 17.9167C5.39069 17.8661 4.0929 17.6546 3.20619 16.7709C2.43012 15.9976 2.1707 14.9104 2.08398 13.1667"
        stroke="#141B34"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.25 14.1667C8.19308 12.1316 11.786 12.0357 13.75 14.1667M12.0792 7.91671C12.0792 9.0673 11.1452 10 9.99294 10C8.84071 10 7.90664 9.0673 7.90664 7.91671C7.90664 6.76611 8.84071 5.83337 9.99294 5.83337C11.1452 5.83337 12.0792 6.76611 12.0792 7.91671Z"
        stroke="#141B34"
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </svg>
  ),
};
